// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M3 4h18l-7 8v6l-4 2v-8z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M9 1.4 L12 3.4 L15 1.4 L13.7 3.6 L12 4.2 L10.3 3.6 Z%27/%3e%3crect x=%279.8%27 y=%273.6%27 width=%274.4%27 height=%273%27 rx=%270.9%27/%3e%3crect x=%277.6%27 y=%277%27 width=%278.8%27 height=%276%27 rx=%271.2%27/%3e%3crect x=%274.4%27 y=%277.4%27 width=%272.6%27 height=%275.8%27 rx=%271.1%27/%3e%3crect x=%2717%27 y=%277.4%27 width=%272.6%27 height=%275.8%27 rx=%271.1%27/%3e%3crect x=%279.4%27 y=%2713.2%27 width=%275.2%27 height=%271.8%27 rx=%270.5%27/%3e%3crect x=%278.7%27 y=%2714.8%27 width=%272.6%27 height=%277%27 rx=%270.9%27/%3e%3crect x=%2712.7%27 y=%2714.8%27 width=%272.6%27 height=%277%27 rx=%270.9%27/%3e%3crect x=%278.4%27 y=%2720.8%27 width=%273.2%27 height=%272.2%27 rx=%270.6%27/%3e%3crect x=%2712.4%27 y=%2720.8%27 width=%273.2%27 height=%272.2%27 rx=%270.6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M4 6h16v2H4zM4 11h16v2H4zM4 16h16v2H4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M17.65 6.35A8 8 0 1 0 19.73 14h-2.08A6 6 0 1 1 12 6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M16 17v-3H9v-4h7V7l5 5zM14 2a2 2 0 0 1 2 2v2h-2V4H5v16h9v-2h2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7zm-5 16a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm3-10H5V5h10z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M10 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M3 5h2v2H3zM7 5h14v2H7zM3 11h2v2H3zM7 11h14v2H7zM3 17h2v2H3zM7 17h14v2H7z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M3 3h8v8H3zM13 3h8v8h-8zM3 13h8v8H3zM13 13h8v8h-8z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 15h-2v-6h2zm0-8h-2V7h2z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M6 6h2v12H6zM19 6v12l-9-6z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M15 6v12l-9-6z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M9 6v12l9-6z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M16 6h2v12h-2zM5 6v12l9-6z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3zM19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7h-2z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5S10.5 3.17 10.5 4v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M12 2C6.48 2 2 5.81 2 10.5c0 2.68 1.46 5.07 3.75 6.64-.13 1.2-.64 2.3-1.42 3.16-.26.28-.05.74.33.7 2-.2 3.67-.9 4.9-1.85.77.16 1.58.25 2.44.25 5.52 0 10-3.81 10-8.5S17.52 2 12 2z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M4 9V4h5v2H6v3zM15 4h5v5h-2V6h-3zM6 15v3h3v2H4v-5zM18 15h2v5h-5v-2h3z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M9 4v5H4V7h3V4zM15 4h2v3h3v2h-5zM4 15h5v5H7v-3H4zM20 15v2h-3v3h-2v-5z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3e%3cpath d=%27M7 10l5 5 5-5z%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.release-group {
  display: contents;
}

.release-group__header {
  grid-column: 1 / -1;
  color: #c4b5fd;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 0.75rem 0.25rem 0.35rem;
  text-transform: uppercase;
}

.release-group__header:first-child {
  padding-top: 0.25rem;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  /* "Cosmos" background: deep-space gradient + soft edge vignette, pinned to the viewport. */
  background:
    radial-gradient(125% 125% at 50% 50%, transparent 55%, rgba(0, 0, 0, 0.55) 100%),
    radial-gradient(140% 110% at 50% -10%, #141a3d 0%, #0b1030 45%, #05060f 100%);
  /* PERF: dropped \`background-attachment: fixed;\` — the ::before/::after atmosphere
     layers are already position:fixed, so the base gradient stays effectively pinned
     while avoiding fixed-background repaint cost. Original rule kept for reference:
     background-attachment: fixed; */
  color: #eee;
  min-height: 100vh;
  position: relative;
  /* Idle animations mount transient actors on <body> that slide in from
     off-stage (e.g. the alien's translate(900px) entry). Clip horizontal
     overflow so those off-stage positions never introduce a page scrollbar. */
  overflow-x: hidden;
}

/* ============================================================================
   ARTISTIC BACKDROP — "Cosmos"
   Fixed, pointer-events-free layers sitting behind all content (negative
   z-index) so they add atmosphere without affecting layout or clicks:
     body::before — a slowly ROTATING multi-hue nebula ring (heavily blurred)
     body::after  — a tiled starfield that gently drifts upward and twinkles
   Pure CSS; honours prefers-reduced-motion below.
   ============================================================================ */
body::before {
  content: '';
  position: fixed;
  /* PERF: reduced overscan from -75% to -30%. -75% made this blurred layer ~6.25x the
     viewport area, which on high-DPI screens exceeds GPU texture-size caps and gets
     downscaled (the "low res" nebula) or tiled (jank). -30% keeps ~1.6x overscan —
     still enough that no hard edge rotates into view. Original: inset: -75%; */
  inset: -30%;
  z-index: -3;
  pointer-events: none;
  background: conic-gradient(
    from 0deg at 50% 50%,
    rgba(124, 58, 237, 0.22) 0deg,
    rgba(56, 189, 248, 0.16) 70deg,
    rgba(236, 72, 153, 0.20) 150deg,
    rgba(45, 212, 191, 0.14) 220deg,
    rgba(250, 204, 21, 0.10) 290deg,
    rgba(124, 58, 237, 0.22) 360deg
  );
  /* PERF: lowered blur from 90px to 50px. Past ~50px the visual softness is
     indistinguishable but the blur cost grows sharply and inflates the layer size.
     Original: filter: blur(90px) saturate(135%); */
  filter: blur(50px) saturate(135%);
  animation: nebula-rotate 70s linear infinite;
  will-change: transform;
}

body::after {
  content: '';
  position: fixed;
  /* PERF: extend the top by one tile height (-340px) so translating the layer upward
     never reveals an empty edge. Original: inset: 0; */
  inset: -340px 0 0 0;
  z-index: -2;
  pointer-events: none;
  background-image:
    radial-gradient(2px 2px at 12% 18%, rgba(255, 255, 255, 0.95), transparent 60%),
    radial-gradient(2px 2px at 28% 72%, rgba(255, 255, 255, 0.85), transparent 60%),
    radial-gradient(1.5px 1.5px at 46% 34%, rgba(199, 210, 254, 0.90), transparent 60%),
    radial-gradient(2px 2px at 63% 58%, rgba(255, 255, 255, 0.90), transparent 60%),
    radial-gradient(1.5px 1.5px at 77% 12%, rgba(186, 230, 253, 0.85), transparent 60%),
    radial-gradient(2.5px 2.5px at 85% 82%, rgba(255, 255, 255, 0.95), transparent 60%),
    radial-gradient(1.5px 1.5px at 91% 46%, rgba(255, 255, 255, 0.80), transparent 60%),
    radial-gradient(1.5px 1.5px at 8% 88%, rgba(255, 255, 255, 0.80), transparent 60%);
  background-size: 340px 340px;
  background-repeat: repeat;
  /* PERF: drift now animates \`transform: translateY()\` (compositor-accelerated, no
     repaint) instead of \`background-position\` (repainted every frame). Same visual
     drift, far cheaper. Original animation:
       star-drift 140s linear infinite,
       star-twinkle 5.5s ease-in-out infinite alternate; */
  animation:
    star-drift 140s linear infinite,
    star-twinkle 5.5s ease-in-out infinite alternate;
  /* PERF: promote transform (compositor) instead of background-position (paint).
     Original: will-change: background-position, opacity; */
  will-change: transform, opacity;
}

@keyframes nebula-rotate {
  to { transform: rotate(360deg); }
}

@keyframes star-drift {
  /* PERF: animate transform (compositor-accelerated) instead of background-position.
     680px == 2 tile heights (340px), so the repeating starfield loops seamlessly.
     Original keyframe:
       from { background-position: 0 0; }
       to   { background-position: 0 -680px; } */
  from { transform: translate3d(0, 0, 0); }
  to   { transform: translate3d(0, -680px, 0); }
}

@keyframes star-twinkle {
  from { opacity: 0.65; }
  to   { opacity: 1; }
}

/* Respect users who prefer reduced motion: keep the art, drop the movement. */
@media (prefers-reduced-motion: reduce) {
  body::before,
  body::after {
    animation: none;
  }
}

.app-shell {
  /* Height reserved for the fixed header. Reused for the content offset below and for the
     desktop panels' max-height calc so everything stays in sync if the header size changes. */
  --app-header-height: 70px;
  display: flex;
  flex-direction: column;
  /* Lock the shell to the viewport so scrolling happens inside .app-container (below the fixed
     header) rather than on the window. This keeps the scrollbar from spanning the full page height. */
  height: 100vh;
  /* The header is position: fixed (out of flow), so reserve its height here to keep the
     content below it from slipping underneath. */
  padding-top: var(--app-header-height);
}

.app-container {
  width: 100%;
  padding: 1.5rem 1rem;
  /* Grow to fill the space under the header and lay out as a column so the main
     content can expand and keep the footer pinned to the bottom on short pages. */
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  /* Positioning context for the calendar-anchored idle-animation stage
     (.idle-stage--calendar), which is absolutely positioned over the calendar. */
  position: relative;
  /* This is the scroll region: it sits below the fixed header, so its scrollbar starts under the
     header instead of running the full viewport height. Kept full-width (max-width lives on the
     inner content below) so the scrollbar sits at the viewport edge, not at a centered column edge. */
  overflow-y: auto;
  min-height: 0;
}

/* Center the actual content within the full-width scroll container so the scrollbar stays at the
   viewport edge while the content keeps its max reading width. */
.app-container > .main-layout,
.app-container > .loading,
.app-container > .error,
.app-container > app-footer {
  width: 100%;
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
}

.app-header {
  /* Fixed so the header stays pinned to the top in every layout regardless of which element
     scrolls (on desktop the panels scroll internally and the window does not, so sticky was
     invisible there; fixed pins it unconditionally). Its height is reserved via
     .app-shell padding-top so content below never slips underneath. It still acts as the
     positioning context for the absolutely-positioned .header-actions. The high z-index keeps it
     above page content and the decorative Cosmos background layers. Header component is
     containerless, so this <header> is a direct child of .app-shell. */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 0;
  padding: 1rem 1.5rem;
  background: linear-gradient(135deg, #1c2c44 0%, #24405f 50%, #1c2c44 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

.app-header h1 {
  font-size: 1.8rem;
  color: #fff;
  text-align: center;
}

/* The robot figure logo pops in red against the dark header, while the title stays white. */
.app-header h1 .icon--toy {
  color: #e53935;
}

/* --- Icon system ---
   Solid, single-color icons rendered via CSS masks. Each glyph is a monochrome
   SVG silhouette painted with the current text color, so icons always match the
   color of whatever control they sit in. Size tracks font-size (1em) by default;
   set width/height (or font-size) on the element to override. */
.icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  flex-shrink: 0;
  vertical-align: -0.125em;
  background-color: currentColor;
  -webkit-mask: var(--icon) no-repeat center / contain;
  mask: var(--icon) no-repeat center / contain;
}

.icon--filter { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }
.icon--toy { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }
.icon--list { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }
.icon--refresh { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }
.icon--signout { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }
.icon--close { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); }
.icon--save { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); }
.icon--folder { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_7___}); }
.icon--view-list { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_8___}); }
.icon--view-grid { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___}); }
.icon--info { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___}); }
.icon--page-first { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___}); }
.icon--page-prev { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___}); }
.icon--page-next { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___}); }
.icon--page-last { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___}); }
.icon--clock { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___}); }
.icon--external { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_16___}); }
.icon--bell { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_17___}); }
.icon--person { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_18___}); }
.icon--bell-filled { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_19___}); }
.icon--comment { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_20___}); }
.icon--expand { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_21___}); }
.icon--collapse { --icon: url(${___CSS_LOADER_URL_REPLACEMENT_22___}); }

/* Per-context icon sizing. The base icon tracks font-size (1em); these tune the
   handful of spots where the surrounding font-size doesn't map to the wanted glyph size. */
.filter-toggle__icon.icon { width: 1.35rem; height: 1.35rem; }
.admin-menu__icon .icon,
.account-menu__icon .icon { width: 1.15rem; height: 1.15rem; }
.panel-close .icon { width: 1.1rem; height: 1.1rem; }
.filter-search__clear .icon,
.saved-search__delete .icon { width: 0.85rem; height: 0.85rem; }
.saved-search__bell .icon { width: 0.95rem; height: 0.95rem; }
.release-card__bell .icon { width: 1.15rem; height: 1.15rem; }
.filter-search-action .icon { width: 1.1rem; height: 1.1rem; }
.view-toggle__btn .icon { width: 1.15rem; height: 1.15rem; }
.updated-info__btn .icon { width: 1.15rem; height: 1.15rem; }
.releases-expand__btn .icon { width: 1.15rem; height: 1.15rem; }
.releases-pager__btn .icon { width: 1rem; height: 1rem; }
.nav-btn .icon { width: 1rem; height: 1rem; }
.release-source--link .icon { width: 0.85em; height: 0.85em; vertical-align: -0.05em; }
.release-time__icon.icon { width: 3rem; height: 3rem; }
.release-card--grid .release-time__icon.icon { width: 1rem; height: 1rem; }

/* Filter toggle (top-left of the header) — only shown on mobile. */
.filter-toggle {
  display: none;
  position: absolute;
  top: 50%;
  left: 1rem;
  transform: translateY(-50%);
  width: 2.6rem;
  height: 2.6rem;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  color: #e6ecf5;
  cursor: pointer;
  z-index: 200;
  transition: background 0.2s, border-color 0.2s;
}

.filter-toggle:hover {
  background: rgba(255, 255, 255, 0.18);
  border-color: #6ab0ff;
}

.filter-toggle__icon {
  font-size: 1.25rem;
  line-height: 1;
}

/* Drawer close buttons ([X]) — only shown on mobile. */
.panel-close {
  display: none;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  padding: 0;
  background: transparent;
  color: #c3ccdb;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  transition: color 0.2s, background 0.2s;
}

.panel-close:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

/* Dark scrim behind an open mobile drawer. */
.panel-backdrop {
  display: none;
  position: fixed;
  inset: 0;
  z-index: 200;
  background: rgba(0, 0, 0, 0.5);
}

.header-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-top: 0.25rem;
}

/* Header controls cluster: holds the account and admin menus side by side, pinned to the
   right edge of the header. Vertically centered via top/bottom + flex (no transform) so the
   menus' fixed-position backdrops remain anchored to the viewport and can catch outside
   clicks across the whole page. A transform here would trap those fixed backdrops inside
   this box. */
.header-actions {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  z-index: 200;
}

.admin-menu {
  position: relative;
}

.hamburger-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  padding: 0;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.hamburger-btn:hover:not(:disabled),
.hamburger-btn.active {
  background: rgba(255, 255, 255, 0.18);
  border-color: #6ab0ff;
}

.hamburger-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.hamburger-btn__bars,
.hamburger-btn__bars::before,
.hamburger-btn__bars::after {
  display: block;
  width: 1.15rem;
  height: 2px;
  background: #e6ecf5;
  border-radius: 2px;
  transition: transform 0.2s, opacity 0.2s;
}

.hamburger-btn__bars {
  position: relative;
}

.hamburger-btn__bars::before,
.hamburger-btn__bars::after {
  content: "";
  position: absolute;
  left: 0;
}

.hamburger-btn__bars::before {
  top: -6px;
}

.hamburger-btn__bars::after {
  top: 6px;
}

.hamburger-btn.active .hamburger-btn__bars {
  background: transparent;
}

.hamburger-btn.active .hamburger-btn__bars::before {
  transform: translateY(6px) rotate(45deg);
}

.hamburger-btn.active .hamburger-btn__bars::after {
  transform: translateY(-6px) rotate(-45deg);
}

.admin-menu__backdrop {
  position: fixed;
  inset: 0;
  z-index: 40;
}

.admin-menu__dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  z-index: 50;
  min-width: 12rem;
  display: flex;
  flex-direction: column;
  padding: 0.35rem;
  background: #1e2f47;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.5);
}

.admin-menu__item {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.55rem 0.7rem;
  background: transparent;
  color: #e6ecf5;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.95rem;
  text-align: left;
  transition: background 0.15s;
}

.admin-menu__item:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1);
}

.admin-menu__item.active {
  background: rgba(74, 158, 255, 0.25);
}

.admin-menu__item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.admin-menu__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
}

.account-menu {
  position: relative;
}

.account-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 2.6rem;
  padding: 0 0.9rem;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  color: #e6ecf5;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.account-btn:hover:not(:disabled),
.account-btn.active {
  background: rgba(255, 255, 255, 0.18);
  border-color: #6ab0ff;
}

/* The authenticated (avatar-only) menu button is squared to a 1:1 ratio so it
   matches the other icon buttons in the header. The Sign-in button keeps its
   text width via the --signin override below. */
.account-btn:not(.account-btn--signin) {
  width: 2.6rem;
  padding: 0;
}

.account-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.account-btn--signin {
  font-weight: 600;
}

.account-btn__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.7rem;
  height: 1.7rem;
  border-radius: 50%;
  background: #2f6bd8;
  color: #fff;
  font-weight: 600;
  font-size: 0.85rem;
}

.account-menu__backdrop {
  position: fixed;
  inset: 0;
  z-index: 40;
}

.account-menu__dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  z-index: 50;
  min-width: 12rem;
  display: flex;
  flex-direction: column;
  padding: 0.35rem;
  background: #1e2f47;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.5);
}

.account-menu__identity {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  padding: 0.5rem 0.7rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 0.25rem;
}

.account-menu__name {
  color: #e6ecf5;
  font-size: 0.9rem;
  font-weight: 600;
  word-break: break-word;
}

.account-menu__tier {
  color: #8fa6c4;
  font-size: 0.75rem;
  text-transform: capitalize;
}

.account-menu__item {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.55rem 0.7rem;
  background: transparent;
  color: #e6ecf5;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.95rem;
  text-align: left;
  transition: background 0.15s;
}

.account-menu__item:hover {
  background: rgba(255, 255, 255, 0.1);
}

.account-menu__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
}

.app-header .subtitle {
  font-size: 1.1rem;
  color: #aaa;
}

.month-select {
  padding: 0.15rem 1.5rem;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-repeat: no-repeat;
  background-position: right 0.4rem center;
  background-size: 0.8rem;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1.35rem;
  font-weight: 700;
  text-align: center;
  text-align-last: center;
  appearance: none;
}

/* The native dropdown popup renders on a light background, so give the options dark
   text for readable contrast (the closed control keeps its light-on-dark header styling). */
.month-select option {
  color: #1a2040;
}

.month-select:hover:not(:disabled) {
  color: #cfe0ff;
}

.month-select:focus-visible {
  outline: 2px solid #6ab0ff;
  outline-offset: 2px;
}

.month-select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.nav-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.2rem;
  height: 2.2rem;
  padding: 0;
  background: rgba(255, 255, 255, 0.08);
  color: #dfe4ee;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
  transition: background 0.2s, color 0.2s;
}

.nav-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
}

.nav-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 2.2rem;
  height: 2.2rem;
  padding: 0;
  background: #2a4a6a;
  color: #fff;
  border: 1px solid #4a9eff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
  transition: background 0.2s;
}

.icon-btn:hover:not(:disabled) {
  background: #3a5a7a;
}

.icon-btn.active {
  background: #4a9eff;
  border-color: #6ab0ff;
}

.icon-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.icon-spinner {
  display: inline-flex;
  line-height: 1;
}

.spinner-ring {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: icon-spin 0.7s linear infinite;
}

@keyframes icon-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* --- Filters (always-visible left panel) --- */

.panel-left {
  background: linear-gradient(150deg, #545d73 0%, #434c60 52%, #3b4559 100%);
  border-radius: 10px;
  padding: 1rem;
  /* Account for the fixed header height so the internally-scrolling panel isn't clipped at the bottom. */
  max-height: calc(100vh - 160px - var(--app-header-height));
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: hidden;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.07);
}

.filter-group {
  display: flex;
  flex-direction: column;
}

/* The Sources group grows to consume the panel's remaining height so its checklist can extend to
   the panel's max-height (matching the RELEASES panel) instead of being capped at a fixed size.
   min-height: 0 lets the inner scroll area shrink correctly inside the flex column. */
.filter-group--sources {
  flex: 1 1 auto;
  min-height: 0;
}

.filter-group__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.4rem;
}

.filter-group__label {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #c3ccdb;
  display: block;
  margin-bottom: 0.4rem;
}

.filter-group__header .filter-group__label {
  margin-bottom: 0;
}

.filter-group__actions {
  display: flex;
  gap: 0.3rem;
}

.filter-action {
  background: none;
  border: none;
  color: #9ecbff;
  font-size: 0.65rem;
  cursor: pointer;
  padding: 0.1rem 0.3rem;
  border-radius: 3px;
  transition: background 0.2s, color 0.2s;
}

.filter-action:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.filter-checklist {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  flex: 1 1 auto;
  min-height: 6rem;
  overflow-y: auto;
  overscroll-behavior: contain;
}

/* Shared dark-theme scrollbar styling. Applied to every scroll container so the
   Filter panel, Releases panel, saved-search list, log view and the main app
   container all match instead of some falling back to the heavier default browser scrollbar. */
.filter-checklist,
.releases-list,
.saved-search__list,
.log-content,
.app-container {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
}

.filter-checklist::-webkit-scrollbar,
.releases-list::-webkit-scrollbar,
.saved-search__list::-webkit-scrollbar,
.log-content::-webkit-scrollbar,
.app-container::-webkit-scrollbar {
  width: 8px;
}

.filter-checklist::-webkit-scrollbar-thumb,
.releases-list::-webkit-scrollbar-thumb,
.saved-search__list::-webkit-scrollbar-thumb,
.log-content::-webkit-scrollbar-thumb,
.app-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.filter-checklist::-webkit-scrollbar-thumb:hover,
.releases-list::-webkit-scrollbar-thumb:hover,
.saved-search__list::-webkit-scrollbar-thumb:hover,
.log-content::-webkit-scrollbar-thumb:hover,
.app-container::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.35);
}

.filter-check {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.35rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  color: #e4e8f0;
  transition: background 0.2s;
}

.filter-check:hover {
  background: rgba(255, 255, 255, 0.08);
}

.filter-check input[type='checkbox'] {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  accent-color: #4a9eff;
  cursor: pointer;
}

.filter-check__label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filter-search-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.filter-search {
  width: 100%;
  padding: 0.4rem 1.8rem 0.4rem 0.6rem;
  font-size: 0.8rem;
  background: transparent;
  color: #eee;
  border: none;
  border-radius: 0;
  outline: none;
}

.filter-search__clear {
  position: absolute;
  right: 0.4rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.1rem;
  height: 1.1rem;
  padding: 0;
  background: #3a4a6a;
  color: #ccc;
  border: none;
  border-radius: 50%;
  font-size: 0.65rem;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.filter-search__clear:hover {
  background: #e94560;
  color: #fff;
}

.filter-search::placeholder {
  color: #9aa3b4;
}

.saved-search {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.filter-search-row {
  display: flex;
  align-items: stretch;
  background: rgba(15, 22, 41, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 6px;
  transition: border-color 0.2s;
}

.filter-search-row:focus-within {
  border-color: #4a9eff;
}

.filter-search-row .filter-search-wrap {
  flex: 1;
  min-width: 0;
}

.filter-search-action {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.1rem;
  padding: 0;
  background: transparent;
  color: #cdd8e6;
  border: none;
  border-left: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 0;
  font-size: 0.95rem;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.filter-search-action:hover,
.filter-search-action.active {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.filter-search-action:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.filter-search-action:disabled:hover {
  background: transparent;
  color: #cdd8e6;
}

.filter-search-load {
  position: relative;
  display: flex;
}

.filter-search-load .filter-search-action {
  border-radius: 0 5px 5px 0;
}

.saved-search-menu__backdrop {
  position: fixed;
  inset: 0;
  z-index: 40;
}

.saved-search-menu__dropdown {
  position: absolute;
  top: calc(100% + 0.4rem);
  right: 0;
  z-index: 50;
  width: max(14rem, 100%);
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 0.5rem;
  background: #1e2f47;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.5);
}

.saved-search__list {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  max-height: 9rem;
  overflow-y: auto;
  padding-right: 0.25rem;
}

.saved-search__empty {
  margin: 0;
  color: #aab3c4;
  font-style: italic;
  font-size: 0.78rem;
  padding: 0.2rem 0.35rem;
}

.saved-search__error {
  margin: 0.1rem 0 0;
  color: #ff9b9b;
  font-size: 0.75rem;
  padding: 0.1rem 0.35rem;
}

.saved-search__hint {
  margin: 0.1rem 0 0;
  color: #8fa6c4;
  font-size: 0.72rem;
  padding: 0.1rem 0.35rem;
}

.saved-search__item {
  display: flex;
  align-items: stretch;
  gap: 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  overflow: hidden;
}

.saved-search__load {
  flex: 1;
  min-width: 0;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0.3rem 0.45rem;
  font-size: 0.8rem;
  background: rgba(255, 255, 255, 0.05);
  color: #e4e8f0;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.saved-search__load:hover {
  background: rgba(255, 255, 255, 0.12);
}

.saved-search__delete {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  padding: 0;
  background: #3a4a6a;
  color: #ccc;
  border: none;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 0;
  font-size: 0.7rem;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.saved-search__delete:hover {
  background: #e94560;
  color: #fff;
}

/* Scale the busy spinner to the compact delete button and keep the hover tint off while pending. */
.saved-search__delete .spinner-ring {
  width: 0.85rem;
  height: 0.85rem;
  border-width: 2px;
}

.saved-search__delete:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #3a4a6a;
  color: #ccc;
}

.saved-search__bell {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  padding: 0;
  background: #3a4a6a;
  color: #ccc;
  border: none;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 0;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.saved-search__bell:hover {
  background: #4a5a7a;
  color: #fff;
}

.saved-search__bell.is-active {
  background: #6366f1;
  color: #fff;
}

.saved-search__bell.is-active:hover {
  background: #7275f3;
}

.loading {
  text-align: center;
  padding: 2rem;
  color: #aaa;
  font-size: 1.1rem;
}

.error {
  text-align: center;
  padding: 1rem;
  color: #ff6b6b;
  background: #2d1b1b;
  border-radius: 8px;
  margin-bottom: 1rem;
}

/* --- Two-panel horizontal layout --- */

.main-layout {
  display: grid;
  grid-template-columns: 260px 1fr 700px;
  gap: 1rem;
  align-items: start;
  /* Absorb the free vertical space inside .app-container so the footer is pushed
     to the bottom of the viewport when the content is shorter than the page. */
  flex: 1 0 auto;
}

/* Stack the three main panels (filter / calendar / releases) above every idle
   animation stage so decorative animations always render layered BETWEEN the
   panels and the background, never over the panels themselves. The animation
   stages sit at negative or low z-index (.idle-stage--fullpage/.idle-stage--page
   at -1, .toy-parade-strip at 0, .idle-stage--calendar at 1); giving the panels
   a positive z-index keeps all of them below the panels. position: relative is
   required for z-index to take effect on these grid items. */
.panel-left,
.panel-center,
.panel-right {
  position: relative;
  z-index: 5;
}

/* Expanded releases: collapse to a single column and let the releases panel span it,
   hiding the filter and calendar so the releases fill the entire main layout. Scoped to the
   full three-column desktop layout; below 1250px the panel is already full-width or a drawer. */
@media (min-width: 1251px) {
  .main-layout.is-expanded {
    grid-template-columns: 1fr;
  }

  .main-layout.is-expanded > .panel-left,
  .main-layout.is-expanded > .panel-center {
    display: none;
  }

  .main-layout.is-expanded > .panel-right {
    grid-column: 1 / -1;
  }

  /* With the panel spanning the full layout there is room for many more cards per row. */
  .main-layout.is-expanded .releases-list--grid {
    grid-template-columns: repeat(10, 1fr);
  }
}

/* --- Calendar header (month navigation lives here) --- */

.calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 0.6rem;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.18);
}

/* Keeps the nav group visually centered by mirroring the reload button's width. */
.calendar-header__spacer {
  width: 2.2rem;
  flex: 0 0 auto;
}

.calendar-header__nav {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* --- Releases header (title / date / view controls) --- */

.releases-header {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.18);
  margin-bottom: 0.5rem;
  flex-shrink: 0;
}

.releases-header__title {
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #c3ccdb;
  justify-self: start;
}

.releases-header__date {
  font-size: 1.3rem;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  justify-self: center;
  text-align: center;
}

.releases-header__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-self: end;
}

.view-toggle {
  display: inline-flex;
  border: 1px solid #4a9eff;
  border-radius: 6px;
  overflow: hidden;
}

.view-toggle__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  height: 1.9rem;
  padding: 0 0.4rem;
  background: #16213e;
  color: #aab6c6;
  border: none;
  cursor: pointer;
  font-size: 0.95rem;
  transition: background 0.2s, color 0.2s;
}

.view-toggle__btn + .view-toggle__btn {
  border-left: 1px solid #4a9eff;
}

.view-toggle__btn:hover:not(.active) {
  background: #1e2a4a;
  color: #fff;
}

.view-toggle__btn.active {
  background: #2a4a6a;
  color: #fff;
}

.updated-info {
  position: relative;
  display: inline-flex;
}

.updated-info__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  padding: 0;
  background: transparent;
  color: #6a7a8a;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: color 0.2s, background 0.2s, border-color 0.2s;
}

.updated-info__btn:hover,
.updated-info__btn.active {
  color: #4a9eff;
  background: #1e2a4a;
}

.updated-info__popover {
  position: absolute;
  top: calc(100% + 0.4rem);
  right: 0;
  z-index: 20;
  padding: 0.35rem 0.6rem;
  background: #0f1629;
  border: 1px solid #333;
  border-radius: 6px;
  font-size: 0.7rem;
  color: #aab6c6;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

/* Expand/collapse toggle: matches the info button's ghost style. Hidden on the small-screen
   layouts where the releases panel is already full-width or a drawer. */
.releases-expand__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  padding: 0;
  background: transparent;
  color: #6a7a8a;
  border: 1px solid #4a9eff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: color 0.2s, background 0.2s, border-color 0.2s;
}

.releases-expand__btn:hover,
.releases-expand__btn.active {
  color: #4a9eff;
  background: #1e2a4a;
}

/* --- Log section (below calendar, collapsible) --- */

.log-section {
  margin-top: 1rem;
}

.log-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.5rem;
}

.log-count {
  font-size: 0.72rem;
  color: #8ab4f8;
  font-family: 'Cascadia Code', 'Fira Code', monospace;
}

.log-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.log-clear-btn {
  font-size: 0.72rem;
  color: #8ab4f8;
  background: #16213e;
  border: 1px solid #2a3a5a;
  border-radius: 6px;
  padding: 0.2rem 0.6rem;
  cursor: pointer;
}

.log-clear-btn:hover:not(:disabled) {
  background: #1e2d4d;
}

.log-clear-btn:disabled {
  opacity: 0.4;
  cursor: default;
}

.log-content {
  font-size: 0.72rem;
  font-family: 'Cascadia Code', 'Fira Code', monospace;
  color: #8ab4f8;
  line-height: 1.5;
  background: #16213e;
  border-radius: 8px;
  padding: 0.75rem;
  margin-top: 0.5rem;
  max-height: 200px;
  overflow-y: auto;
}

.log-empty {
  color: #555;
  font-style: italic;
}

.diag-line {
  padding: 0.2rem 0;
  border-bottom: 1px solid #1a2a3a;
}

.diag-line:last-child {
  border-bottom: none;
}

/* --- Center panel: Calendar --- */

.panel-center {
  min-width: 0;
  background: linear-gradient(150deg, #545d73 0%, #434c60 52%, #3b4559 100%);
  border-radius: 10px;
  padding: 1rem;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.07);
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  background: #5b657c;
  border-radius: 10px;
  overflow: hidden;
  padding: 2px;
  transition: opacity 0.2s;
}

.calendar-grid.is-loading {
  opacity: 0.5;
  pointer-events: none;
}

/* Wrapper positions the loading overlay over the grid while a month's data loads. */
.calendar-grid-wrap {
  position: relative;
}

.calendar-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  border-radius: 10px;
  background: rgba(59, 69, 89, 0.35);
  backdrop-filter: blur(1px);
}

.calendar-loading-spinner {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.25);
  border-top-color: #ffffff;
  animation: icon-spin 0.7s linear infinite;
}

.calendar-loading-text {
  font-size: 0.85rem;
  font-weight: 600;
  color: #e7edf6;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}

.day-header {
  text-align: center;
  padding: 0.6rem 0.25rem;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #c3ccdb;
  background: #4c5670;
}

.calendar-day {
  background: #414b5f;
  padding: 0.4rem;
  min-height: 60px;
  position: relative;
  cursor: default;
  transition: background 0.2s;
}

.calendar-day.other-month {
  background: #333c4d;
  opacity: 0.4;
}

.calendar-day.has-releases {
  cursor: pointer;
  background: #49546b;
}

.calendar-day.has-releases:hover {
  background: #576480;
}

.calendar-day.selected {
  background: #3f5c84;
  border: 2px solid #6ab0ff;
}

.day-number {
  font-size: 0.85rem;
  font-weight: 500;
  color: #eef1f6;
}

.calendar-day.today .day-number {
  color: #4eff6a;
  font-weight: 700;
}

.release-count {
  position: absolute;
  bottom: 4px;
  right: 4px;
  background: #e94560;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* --- Right panel: Releases --- */

.panel-right {
  background: linear-gradient(150deg, #545d73 0%, #434c60 52%, #3b4559 100%);
  border-radius: 10px;
  padding: 1rem;
  /* Account for the fixed header height so the internally-scrolling panel isn't clipped at the bottom. */
  max-height: calc(100vh - 160px - var(--app-header-height));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.07);
}

.releases-content {
  font-size: 0.85rem;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.releases-empty {
  color: #aab3c4;
  font-style: italic;
  text-align: center;
  padding: 1.5rem 0.5rem;
}

.releases-detail {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  /* Anchors the paging loading overlay over the list and pager. */
  position: relative;
}

.releases-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  /* Prevent scroll chaining: once the list reaches its top/bottom, the wheel no longer
     bubbles up and scrolls the whole page. */
  overscroll-behavior: contain;
  transition: opacity 0.2s;
}

/* Dim the outgoing page while the next one loads, matching the calendar grid's behaviour. */
.releases-list.is-loading {
  opacity: 0.5;
  pointer-events: none;
}

/* Grid view: compact cards laid out 4 per row. */
.releases-list--grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.6rem;
  align-content: start;
}

.releases-list--grid release {
  display: block;
  min-width: 0;
}

.releases-list--grid release + release {
  margin-top: 0;
}

.releases-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  flex-shrink: 0;
  padding-top: 0.75rem;
  margin-top: 0.5rem;
  border-top: 1px solid rgba(74, 158, 255, 0.18);
}

.releases-pager__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  height: 2rem;
  padding: 0 0.5rem;
  background: #2a4a6a;
  color: #fff;
  border: 1px solid #4a9eff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: background 0.2s;
}

.releases-pager__btn:hover:not(:disabled) {
  background: #3a5a7a;
}

.releases-pager__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.releases-pager__label {
  color: #4a9eff;
  font-size: 0.8rem;
  min-width: 6.5rem;
  text-align: center;
}

release {
  display: block;
}

release + release {
  margin-top: 1px;
}

.release-card {
  background: #1e2a4a;
  border-radius: 8px;
  padding: 0;
  margin-bottom: 0.6rem;
  border-left: 3px solid #e94560;
  overflow: hidden;
}

.release-card__body {
  display: flex;
  gap: 0;
  align-items: stretch;
}

.release-thumb {
  width: 90px;
  min-height: 90px;
  aspect-ratio: 1;
  object-fit: cover;
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.2s;
  background: #0f1629;
}

.release-thumb:hover {
  opacity: 0.8;
}

.release-card__content {
  flex: 1;
  min-width: 0;
  padding: 0.75rem;
}

.release-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem;
}

.release-card__info {
  flex: 1;
  min-width: 0;
}

.release-card__meta {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.4rem;
}

.release-card__bell {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  padding: 0;
  background: rgba(255, 255, 255, 0.06);
  color: #9aa4bf;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
}

.release-card--list .release-card__bell {
  width: 1.6rem;
  height: 1.6rem;
}

.release-card--list .release-card__bell .icon {
  width: 0.95rem;
  height: 0.95rem;
}

.release-card__bell:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #e4e8f0;
  border-color: rgba(158, 203, 255, 0.5);
}

.release-card__bell.is-active {
  background: #6366f1;
  color: #fff;
  border-color: #6366f1;
}

.release-card__bell.is-active:hover {
  background: #7275f3;
  border-color: #7275f3;
}

.release-card:last-child {
  margin-bottom: 0;
}

.release-source {
  font-size: 0.65rem;
  text-transform: uppercase;
  color: #888;
  margin-bottom: 0.15rem;
}

.release-source--link {
  text-decoration: none;
  color: #888;
  transition: color 0.2s;
}

.release-source--link:hover {
  color: #4a9eff;
  text-decoration: underline;
}

.release-brand {
  font-size: 0.95rem;
  font-weight: 700;
  color: #4a9eff;
}

.release-line {
  font-size: 0.85rem;
  color: #ccc;
  margin-top: 0.15rem;
}

.release-time {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.15rem;
  white-space: nowrap;
  padding: 0.3rem 0.6rem;
  background: #1a2040;
  border-radius: 6px;
  flex-shrink: 0;
}

.release-time__icon {
  font-size: 1.4rem;
  line-height: 1;
}

.release-time__text {
  font-size: 1.05rem;
  font-weight: 700;
  color: #ffd700;
}

.release-note {
  font-size: 0.75rem;
  color: #888;
  margin-top: 0.3rem;
  font-style: italic;
  line-height: 1.4;
}

.release-price {
  font-size: 0.9rem;
  font-weight: 700;
  color: #4caf50;
  white-space: nowrap;
  margin-top: 0.3rem;
}

/* --- Grid-view compact card (stacked: image on top, details below) --- */

.release-card--grid {
  margin-bottom: 0;
  height: 100%;
}

.release-card--grid .release-card__body {
  flex-direction: column;
}

.release-card--grid .release-thumb {
  width: 100%;
  height: 130px;
  min-height: 0;
  aspect-ratio: auto;
}

.release-card--grid .release-card__content {
  padding: 0.6rem;
}

.release-card--grid .release-card__header {
  flex-direction: column;
  gap: 0.35rem;
}

.release-card--grid .release-card__meta {
  flex-direction: row;
  align-items: center;
  align-self: flex-start;
  gap: 0.4rem;
}

.release-card--grid .release-time {
  flex-direction: row;
  gap: 0.3rem;
  padding: 0.2rem 0.45rem;
  align-self: flex-start;
}

.release-card--grid .release-time__icon {
  font-size: 1rem;
}

.release-card--grid .release-time__text {
  font-size: 0.9rem;
}

/* --- Lightbox --- */

/* --- Login modal --- */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.login-modal {
  width: min(90vw, 340px);
  background: #1c2c40;
  border: 1px solid #4a9eff;
  border-radius: 10px;
  padding: 1.4rem;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.login-modal__title {
  margin: 0;
  color: #fff;
  font-size: 1.15rem;
}

.login-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  color: #cdd8e6;
  font-size: 0.85rem;
}

.login-field input {
  padding: 0.55rem 0.6rem;
  background: #12202f;
  color: #fff;
  border: 1px solid #34506e;
  border-radius: 6px;
  font-size: 0.95rem;
}

.login-field input:focus {
  outline: none;
  border-color: #4a9eff;
}

.login-check {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #cdd8e6;
  font-size: 0.85rem;
  cursor: pointer;
  user-select: none;
}

.login-check input[type='checkbox'] {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  accent-color: #4a9eff;
  cursor: pointer;
}

.login-error {
  color: #ff8080;
  font-size: 0.85rem;
}

.save-search__nudge {
  margin: 0;
  color: #9fb0c3;
  font-size: 0.85rem;
  line-height: 1.4;
}

.save-search__nudge-link {
  background: none;
  border: none;
  padding: 0;
  color: #4a9eff;
  font: inherit;
  cursor: pointer;
  text-decoration: underline;
}

.save-search__nudge-link:hover {
  color: #6fb2ff;
}

.login-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
  margin-top: 0.2rem;
}

.login-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.5rem 0.9rem;
  border-radius: 6px;
  border: 1px solid transparent;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.2s;
}

.login-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.login-btn--primary {
  background: #4a9eff;
  color: #fff;
}

.login-btn--primary:hover:not(:disabled) {
  background: #5aabff;
}

.login-btn--secondary {
  background: transparent;
  color: #cdd8e6;
  border-color: #34506e;
}

.login-btn--secondary:hover:not(:disabled) {
  background: #23384f;
}

/* --- Hidden admin sign-in hotspot ---
   An invisible click target tucked into the bottom-right corner. It carries no
   visible styling so only someone who knows it is there can find it. */
.admin-hotspot {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 28px;
  height: 28px;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  opacity: 0;
  cursor: default;
  z-index: 1200;
  -webkit-tap-highlight-color: transparent;
}

.admin-hotspot:focus {
  outline: none;
}

/* --- Footer --- */

.app-footer {
  position: relative;
  margin-top: 2.5rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(74, 158, 255, 0.18);
  text-align: center;
  color: #8a97a8;
  font-size: 0.8rem;
  line-height: 1.5;
}

.app-footer__links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  margin-bottom: 0.6rem;
}

.footer-link {
  background: none;
  border: none;
  padding: 0;
  color: #9fb4cc;
  font-size: 0.8rem;
  font-family: inherit;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s;
}

.footer-link:hover {
  color: #4a9eff;
  text-decoration: underline;
}

.footer-link--icon {
  display: inline-flex;
  align-items: center;
  line-height: 0;
}

.footer-link--icon:hover {
  text-decoration: none;
}

.footer-icon {
  width: 1rem;
  height: 1rem;
  display: block;
}

.footer-sep {
  color: #4a5a6e;
  user-select: none;
}

.app-footer__copyright {
  color: #aab6c6;
  margin-bottom: 0.4rem;
}

.app-footer__note {
  max-width: 720px;
  margin: 0 auto;
  color: #6f7c8c;
  font-size: 0.72rem;
}

.app-footer__made-in {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  margin-top: 0.75rem;
  color: #8a97a8;
  font-size: 0.68rem;
  letter-spacing: 0.08em;
}

.pr-flag {
  width: 1.1rem;
  height: auto;
  border-radius: 2px;
  display: block;
}

/* ------------------------------------------------------------------ */
/* Responsive / mobile                                                */
/* ------------------------------------------------------------------ */

/* Narrow desktops / large tablets: keep the filter beside the calendar but move
   the releases panel to a full-width row below so the calendar keeps usable width. */
@media (max-width: 1250px) {
  .main-layout {
    grid-template-columns: 240px 1fr;
  }

  .panel-right {
    grid-column: 1 / -1;
  }

  /* The releases panel is already full-width here, so the expand affordance is redundant. */
  .releases-expand__btn {
    display: none;
  }
}

/* Tablets and below: stack the filter, calendar, and releases panels so the
   fixed sidebar no longer forces horizontal scrolling. */
@media (max-width: 900px) {
  .main-layout {
    grid-template-columns: 1fr;
  }

  /* When stacked, cap the filter panel height so its brand list stays scrollable
     instead of pushing the calendar far down the page. */
  .panel-left {
    max-height: 320px;
  }

  /* When stacked, let the releases panel flow with the page instead of
     trapping content inside a fixed-height inner scroll region. */
  .panel-right {
    max-height: none;
    overflow: visible;
  }

  .releases-list {
    overflow-y: visible;
  }
}

/* Phones: tighten chrome, wrap the header controls, and enlarge touch
   targets so the calendar stays usable on narrow screens. */
@media (max-width: 600px) {
  .app-container {
    padding: 1rem 0.75rem;
  }

  .app-header h1 {
    font-size: 1.4rem;
    padding: 0 3.25rem;
  }

  .header-actions {
    right: 0.75rem;
  }

  .filter-toggle {
    display: inline-flex;
    left: 0.75rem;
  }

  .header-row {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  /* Only the calendar occupies the flow on mobile; the filter and releases
     panels become slide-in drawers layered on top of it. */
  .main-layout {
    grid-template-columns: 1fr;
  }

  .panel-close {
    display: inline-flex;
  }

  .panel-backdrop.is-open {
    display: block;
  }

  /* Filter drawer: slides in from the left, over the calendar. */
  .panel-left {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: min(88vw, 340px);
    max-height: none;
    z-index: 210;
    border-radius: 0;
    transform: translateX(-100%);
    transition: transform 0.28s ease;
  }

  .panel-left.is-open {
    transform: translateX(0);
  }

  /* Releases drawer: slides in from the right, over the calendar. */
  .panel-right {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: min(94vw, 480px);
    max-height: none;
    overflow: hidden;
    z-index: 210;
    border-radius: 0;
    padding: 0.75rem;
    transform: translateX(100%);
    transition: transform 0.28s ease;
  }

  .panel-right.is-open {
    transform: translateX(0);
  }

  .releases-list {
    overflow-y: auto;
  }

  /* Recommended minimum ~44px touch targets. */
  .nav-btn,
  .icon-btn {
    min-width: 2.75rem;
    min-height: 2.75rem;
  }

  /* The reload button was added to the calendar header; on narrow screens the balancing
     spacer + larger touch targets + 1rem gaps overflow the row. Drop the spacer (it only
     exists to visually center the nav on desktop) and tighten spacing so the header fits. */
  .calendar-header {
    gap: 0.5rem;
  }

  .calendar-header__spacer {
    display: none;
  }

  .calendar-header__nav {
    flex: 1 1 auto;
    justify-content: center;
    gap: 0.5rem;
    min-width: 0;
  }

  /* Let the month select shrink instead of forcing the row wider than the viewport. */
  .month-select {
    min-width: 0;
    flex: 0 1 auto;
    font-size: 1.15rem;
    padding: 0.15rem 1.35rem;
  }

  .calendar-header__reload {
    flex: 0 0 auto;
  }

  .calendar-day {
    min-height: 48px;
    padding: 0.3rem;
  }

  .day-header {
    padding: 0.4rem 0.15rem;
    font-size: 0.65rem;
  }

  .day-number {
    font-size: 0.8rem;
  }

  .releases-list--grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .release-thumb {
    width: 72px;
    min-height: 72px;
  }

  .release-card--grid .release-thumb {
    width: 100%;
    height: 110px;
  }

  .release-card__content {
    padding: 0.6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8EAA8E;EAC9E,2FAA2F;EAC3F;;iFAE+E;EAC/E;;;oCAGkC;EAClC,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB;;8EAE4E;EAC5E,kBAAkB;AACpB;;AAEA;;;;;;;iFAOiF;AACjF;EACE,WAAW;EACX,eAAe;EACf;;;+EAG6E;EAC7E,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB;;;;;;;;GAQC;EACD;;mDAEiD;EACjD,iCAAiC;EACjC,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf;uDACqD;EACrD,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB;;;;;;;;sFAQoF;EACpF,4BAA4B;EAC5B,yBAAyB;EACzB;;;;0DAIwD;EACxD;;oDAEkD;EAClD;2DACyD;EACzD,+BAA+B;AACjC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;;;;gDAI8C;EAC9C,OAAO,+BAA+B,EAAE;EACxC,OAAO,oCAAoC,EAAE;AAC/C;;AAEA;EACE,OAAO,aAAa,EAAE;EACtB,OAAO,UAAU,EAAE;AACrB;;AAEA,8EAA8E;AAC9E;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;8FAC4F;EAC5F,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB;sGACoG;EACpG,aAAa;EACb;iDAC+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB;kFACgF;EAChF,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB;iFAC+E;EAC/E,kBAAkB;EAClB;;sGAEoG;EACpG,gBAAgB;EAChB,aAAa;AACf;;AAEA;iEACiE;AACjE;;;;EAIE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;;;;;;uEAMqE;EACrE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,0EAA0E;EAC1E,kDAAkD;EAClD,oFAAoF;AACtF;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA,4FAA4F;AAC5F;EACE,cAAc;AAChB;;AAEA;;;;gEAIgE;AAChE;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,8BAA8B;EAC9B,oDAAoD;EACpD,4CAA4C;AAC9C;;AAEA,gBAAgB,+CAAmJ,EAAE;AACrK,aAAa,+CAAitB,EAAE;AAChuB,cAAc,+CAAkK,EAAE;AAClL,iBAAiB,+CAAmN,EAAE;AACtO,iBAAiB,+CAA0O,EAAE;AAC7P,eAAe,+CAAiO,EAAE;AAClP,cAAc,+CAAsO,EAAE;AACtP,gBAAgB,+CAAuM,EAAE;AACzN,mBAAmB,+CAAqM,EAAE;AAC1N,mBAAmB,+CAA8K,EAAE;AACnM,cAAc,gDAA8L,EAAE;AAC9M,oBAAoB,gDAAsJ,EAAE;AAC5K,mBAAmB,gDAA0I,EAAE;AAC/J,mBAAmB,gDAAwI,EAAE;AAC7J,mBAAmB,gDAAsJ,EAAE;AAC3K,eAAe,gDAAkT,EAAE;AACnU,kBAAkB,gDAAoP,EAAE;AACxQ,cAAc,gDAA4U,EAAE;AAC5V,gBAAgB,gDAAyO,EAAE;AAC3P,qBAAqB,gDAA4R,EAAE;AACnT,iBAAiB,gDAA8S,EAAE;AACjU,gBAAgB,gDAAiM,EAAE;AACnN,kBAAkB,gDAAiM,EAAE;;AAErN;2FAC2F;AAC3F,4BAA4B,cAAc,EAAE,eAAe,EAAE;AAC7D;4BAC4B,cAAc,EAAE,eAAe,EAAE;AAC7D,qBAAqB,aAAa,EAAE,cAAc,EAAE;AACpD;8BAC8B,cAAc,EAAE,eAAe,EAAE;AAC/D,4BAA4B,cAAc,EAAE,eAAe,EAAE;AAC7D,4BAA4B,cAAc,EAAE,eAAe,EAAE;AAC7D,8BAA8B,aAAa,EAAE,cAAc,EAAE;AAC7D,0BAA0B,cAAc,EAAE,eAAe,EAAE;AAC3D,2BAA2B,cAAc,EAAE,eAAe,EAAE;AAC5D,8BAA8B,cAAc,EAAE,eAAe,EAAE;AAC/D,6BAA6B,WAAW,EAAE,YAAY,EAAE;AACxD,iBAAiB,WAAW,EAAE,YAAY,EAAE;AAC5C,8BAA8B,aAAa,EAAE,cAAc,EAAE,uBAAuB,EAAE;AACtF,2BAA2B,WAAW,EAAE,YAAY,EAAE;AACtD,+CAA+C,WAAW,EAAE,YAAY,EAAE;;AAE1E,mEAAmE;AACnE;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;cAIc;AACd;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,UAAU;EACV,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;;EAEE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,8CAA8C;AAChD;;AAEA;;EAEE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;;gDAEgD;AAChD;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,0DAAqK;EACrK,4BAA4B;EAC5B,wCAAwC;EACxC,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;4FAC4F;AAC5F;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,UAAU;EACV,qCAAqC;EACrC,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,gDAAgD;;AAEhD;EACE,0EAA0E;EAC1E,mBAAmB;EACnB,aAAa;EACb,uGAAuG;EACvG,0DAA0D;EAC1D,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,mFAAmF;AACrF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;sFAEsF;AACtF;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;+FAE+F;AAC/F;;;;;EAKE,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;;;;;EAKE,UAAU;AACZ;;AAEA;;;;;EAKE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;;;;EAKE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,kCAAkC;EAClC,2CAA2C;EAC3C,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,gDAAgD;EAChD,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA;;EAEE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,MAAM;EACN,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,qCAAqC;EACrC,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,mGAAmG;AACnG;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,wCAAwC;;AAExC;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,kBAAkB;EAClB;+EAC6E;EAC7E,cAAc;AAChB;;AAEA;;;;;;6DAM6D;AAC7D;;;EAGE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;gGAEgG;AAChG;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA,uFAAuF;EACvF;IACE,sCAAsC;EACxC;AACF;;AAEA,0DAA0D;;AAE1D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kDAAkD;EAClD,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,0DAA0D;AAC5D;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;wEACwE;AACxE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,0DAA0D;AAC5D;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA,sDAAsD;;AAEtD;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oDAAoD;EACpD,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;;AAEnC;EACE,YAAY;EACZ,0EAA0E;EAC1E,mBAAmB;EACnB,aAAa;EACb,mFAAmF;AACrF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,oFAAoF;AACpF;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kCAAkC;;AAElC;EACE,0EAA0E;EAC1E,mBAAmB;EACnB,aAAa;EACb,uGAAuG;EACvG,0DAA0D;EAC1D,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mFAAmF;AACrF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,gEAAgE;EAChE,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB;6CAC2C;EAC3C,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA,4FAA4F;AAC5F;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,UAAU;EACV,qCAAqC;EACrC,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,0EAA0E;;AAE1E;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qBAAqB;;AAErB,wBAAwB;;AAExB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;uEAEuE;AACvE;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA,mBAAmB;;AAEnB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,8CAA8C;EAC9C,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;;AAEvE;qFACqF;AACrF;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA,0FAA0F;EAC1F;IACE,aAAa;EACf;AACF;;AAEA;yDACyD;AACzD;EACE;IACE,0BAA0B;EAC5B;;EAEA;yDACuD;EACvD;IACE,iBAAiB;EACnB;;EAEA;kEACgE;EAChE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;4DAC4D;AAC5D;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;2DACyD;EACzD;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA,+DAA+D;EAC/D;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,kEAAkE;EAClE;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA,6CAA6C;EAC7C;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;4FAE0F;EAC1F;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,uBAAuB;IACvB,WAAW;IACX,YAAY;EACd;;EAEA,oFAAoF;EACpF;IACE,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.release-group {\r\n  display: contents;\r\n}\r\n\r\n.release-group__header {\r\n  grid-column: 1 / -1;\r\n  color: #c4b5fd;\r\n  font-size: 0.8rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.04em;\r\n  padding: 0.75rem 0.25rem 0.35rem;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.release-group__header:first-child {\r\n  padding-top: 0.25rem;\r\n}\r\n\r\nbody {\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\r\n  /* \"Cosmos\" background: deep-space gradient + soft edge vignette, pinned to the viewport. */\r\n  background:\r\n    radial-gradient(125% 125% at 50% 50%, transparent 55%, rgba(0, 0, 0, 0.55) 100%),\r\n    radial-gradient(140% 110% at 50% -10%, #141a3d 0%, #0b1030 45%, #05060f 100%);\r\n  /* PERF: dropped `background-attachment: fixed;` — the ::before/::after atmosphere\r\n     layers are already position:fixed, so the base gradient stays effectively pinned\r\n     while avoiding fixed-background repaint cost. Original rule kept for reference:\r\n     background-attachment: fixed; */\r\n  color: #eee;\r\n  min-height: 100vh;\r\n  position: relative;\r\n  /* Idle animations mount transient actors on <body> that slide in from\r\n     off-stage (e.g. the alien's translate(900px) entry). Clip horizontal\r\n     overflow so those off-stage positions never introduce a page scrollbar. */\r\n  overflow-x: hidden;\r\n}\r\n\r\n/* ============================================================================\r\n   ARTISTIC BACKDROP — \"Cosmos\"\r\n   Fixed, pointer-events-free layers sitting behind all content (negative\r\n   z-index) so they add atmosphere without affecting layout or clicks:\r\n     body::before — a slowly ROTATING multi-hue nebula ring (heavily blurred)\r\n     body::after  — a tiled starfield that gently drifts upward and twinkles\r\n   Pure CSS; honours prefers-reduced-motion below.\r\n   ============================================================================ */\r\nbody::before {\r\n  content: '';\r\n  position: fixed;\r\n  /* PERF: reduced overscan from -75% to -30%. -75% made this blurred layer ~6.25x the\r\n     viewport area, which on high-DPI screens exceeds GPU texture-size caps and gets\r\n     downscaled (the \"low res\" nebula) or tiled (jank). -30% keeps ~1.6x overscan —\r\n     still enough that no hard edge rotates into view. Original: inset: -75%; */\r\n  inset: -30%;\r\n  z-index: -3;\r\n  pointer-events: none;\r\n  background: conic-gradient(\r\n    from 0deg at 50% 50%,\r\n    rgba(124, 58, 237, 0.22) 0deg,\r\n    rgba(56, 189, 248, 0.16) 70deg,\r\n    rgba(236, 72, 153, 0.20) 150deg,\r\n    rgba(45, 212, 191, 0.14) 220deg,\r\n    rgba(250, 204, 21, 0.10) 290deg,\r\n    rgba(124, 58, 237, 0.22) 360deg\r\n  );\r\n  /* PERF: lowered blur from 90px to 50px. Past ~50px the visual softness is\r\n     indistinguishable but the blur cost grows sharply and inflates the layer size.\r\n     Original: filter: blur(90px) saturate(135%); */\r\n  filter: blur(50px) saturate(135%);\r\n  animation: nebula-rotate 70s linear infinite;\r\n  will-change: transform;\r\n}\r\n\r\nbody::after {\r\n  content: '';\r\n  position: fixed;\r\n  /* PERF: extend the top by one tile height (-340px) so translating the layer upward\r\n     never reveals an empty edge. Original: inset: 0; */\r\n  inset: -340px 0 0 0;\r\n  z-index: -2;\r\n  pointer-events: none;\r\n  background-image:\r\n    radial-gradient(2px 2px at 12% 18%, rgba(255, 255, 255, 0.95), transparent 60%),\r\n    radial-gradient(2px 2px at 28% 72%, rgba(255, 255, 255, 0.85), transparent 60%),\r\n    radial-gradient(1.5px 1.5px at 46% 34%, rgba(199, 210, 254, 0.90), transparent 60%),\r\n    radial-gradient(2px 2px at 63% 58%, rgba(255, 255, 255, 0.90), transparent 60%),\r\n    radial-gradient(1.5px 1.5px at 77% 12%, rgba(186, 230, 253, 0.85), transparent 60%),\r\n    radial-gradient(2.5px 2.5px at 85% 82%, rgba(255, 255, 255, 0.95), transparent 60%),\r\n    radial-gradient(1.5px 1.5px at 91% 46%, rgba(255, 255, 255, 0.80), transparent 60%),\r\n    radial-gradient(1.5px 1.5px at 8% 88%, rgba(255, 255, 255, 0.80), transparent 60%);\r\n  background-size: 340px 340px;\r\n  background-repeat: repeat;\r\n  /* PERF: drift now animates `transform: translateY()` (compositor-accelerated, no\r\n     repaint) instead of `background-position` (repainted every frame). Same visual\r\n     drift, far cheaper. Original animation:\r\n       star-drift 140s linear infinite,\r\n       star-twinkle 5.5s ease-in-out infinite alternate; */\r\n  animation:\r\n    star-drift 140s linear infinite,\r\n    star-twinkle 5.5s ease-in-out infinite alternate;\r\n  /* PERF: promote transform (compositor) instead of background-position (paint).\r\n     Original: will-change: background-position, opacity; */\r\n  will-change: transform, opacity;\r\n}\r\n\r\n@keyframes nebula-rotate {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n@keyframes star-drift {\r\n  /* PERF: animate transform (compositor-accelerated) instead of background-position.\r\n     680px == 2 tile heights (340px), so the repeating starfield loops seamlessly.\r\n     Original keyframe:\r\n       from { background-position: 0 0; }\r\n       to   { background-position: 0 -680px; } */\r\n  from { transform: translate3d(0, 0, 0); }\r\n  to   { transform: translate3d(0, -680px, 0); }\r\n}\r\n\r\n@keyframes star-twinkle {\r\n  from { opacity: 0.65; }\r\n  to   { opacity: 1; }\r\n}\r\n\r\n/* Respect users who prefer reduced motion: keep the art, drop the movement. */\r\n@media (prefers-reduced-motion: reduce) {\r\n  body::before,\r\n  body::after {\r\n    animation: none;\r\n  }\r\n}\r\n\r\n.app-shell {\r\n  /* Height reserved for the fixed header. Reused for the content offset below and for the\r\n     desktop panels' max-height calc so everything stays in sync if the header size changes. */\r\n  --app-header-height: 70px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* Lock the shell to the viewport so scrolling happens inside .app-container (below the fixed\r\n     header) rather than on the window. This keeps the scrollbar from spanning the full page height. */\r\n  height: 100vh;\r\n  /* The header is position: fixed (out of flow), so reserve its height here to keep the\r\n     content below it from slipping underneath. */\r\n  padding-top: var(--app-header-height);\r\n}\r\n\r\n.app-container {\r\n  width: 100%;\r\n  padding: 1.5rem 1rem;\r\n  /* Grow to fill the space under the header and lay out as a column so the main\r\n     content can expand and keep the footer pinned to the bottom on short pages. */\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* Positioning context for the calendar-anchored idle-animation stage\r\n     (.idle-stage--calendar), which is absolutely positioned over the calendar. */\r\n  position: relative;\r\n  /* This is the scroll region: it sits below the fixed header, so its scrollbar starts under the\r\n     header instead of running the full viewport height. Kept full-width (max-width lives on the\r\n     inner content below) so the scrollbar sits at the viewport edge, not at a centered column edge. */\r\n  overflow-y: auto;\r\n  min-height: 0;\r\n}\r\n\r\n/* Center the actual content within the full-width scroll container so the scrollbar stays at the\r\n   viewport edge while the content keeps its max reading width. */\r\n.app-container > .main-layout,\r\n.app-container > .loading,\r\n.app-container > .error,\r\n.app-container > app-footer {\r\n  width: 100%;\r\n  max-width: 1600px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.app-header {\r\n  /* Fixed so the header stays pinned to the top in every layout regardless of which element\r\n     scrolls (on desktop the panels scroll internally and the window does not, so sticky was\r\n     invisible there; fixed pins it unconditionally). Its height is reserved via\r\n     .app-shell padding-top so content below never slips underneath. It still acts as the\r\n     positioning context for the absolutely-positioned .header-actions. The high z-index keeps it\r\n     above page content and the decorative Cosmos background layers. Header component is\r\n     containerless, so this <header> is a direct child of .app-shell. */\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 100;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n  margin-bottom: 0;\r\n  padding: 1rem 1.5rem;\r\n  background: linear-gradient(135deg, #1c2c44 0%, #24405f 50%, #1c2c44 100%);\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\r\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.06);\r\n}\r\n\r\n.app-header h1 {\r\n  font-size: 1.8rem;\r\n  color: #fff;\r\n  text-align: center;\r\n}\r\n\r\n/* The robot figure logo pops in red against the dark header, while the title stays white. */\r\n.app-header h1 .icon--toy {\r\n  color: #e53935;\r\n}\r\n\r\n/* --- Icon system ---\r\n   Solid, single-color icons rendered via CSS masks. Each glyph is a monochrome\r\n   SVG silhouette painted with the current text color, so icons always match the\r\n   color of whatever control they sit in. Size tracks font-size (1em) by default;\r\n   set width/height (or font-size) on the element to override. */\r\n.icon {\r\n  display: inline-block;\r\n  width: 1em;\r\n  height: 1em;\r\n  flex-shrink: 0;\r\n  vertical-align: -0.125em;\r\n  background-color: currentColor;\r\n  -webkit-mask: var(--icon) no-repeat center / contain;\r\n  mask: var(--icon) no-repeat center / contain;\r\n}\r\n\r\n.icon--filter { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M3 4h18l-7 8v6l-4 2v-8z'/%3e%3c/svg%3e\"); }\r\n.icon--toy { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M9 1.4 L12 3.4 L15 1.4 L13.7 3.6 L12 4.2 L10.3 3.6 Z'/%3e%3crect x='9.8' y='3.6' width='4.4' height='3' rx='0.9'/%3e%3crect x='7.6' y='7' width='8.8' height='6' rx='1.2'/%3e%3crect x='4.4' y='7.4' width='2.6' height='5.8' rx='1.1'/%3e%3crect x='17' y='7.4' width='2.6' height='5.8' rx='1.1'/%3e%3crect x='9.4' y='13.2' width='5.2' height='1.8' rx='0.5'/%3e%3crect x='8.7' y='14.8' width='2.6' height='7' rx='0.9'/%3e%3crect x='12.7' y='14.8' width='2.6' height='7' rx='0.9'/%3e%3crect x='8.4' y='20.8' width='3.2' height='2.2' rx='0.6'/%3e%3crect x='12.4' y='20.8' width='3.2' height='2.2' rx='0.6'/%3e%3c/svg%3e\"); }\r\n.icon--list { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M4 6h16v2H4zM4 11h16v2H4zM4 16h16v2H4z'/%3e%3c/svg%3e\"); }\r\n.icon--refresh { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M17.65 6.35A8 8 0 1 0 19.73 14h-2.08A6 6 0 1 1 12 6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z'/%3e%3c/svg%3e\"); }\r\n.icon--signout { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M16 17v-3H9v-4h7V7l5 5zM14 2a2 2 0 0 1 2 2v2h-2V4H5v16h9v-2h2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z'/%3e%3c/svg%3e\"); }\r\n.icon--close { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3e%3c/svg%3e\"); }\r\n.icon--save { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7zm-5 16a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm3-10H5V5h10z'/%3e%3c/svg%3e\"); }\r\n.icon--folder { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M10 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8z'/%3e%3c/svg%3e\"); }\r\n.icon--view-list { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M3 5h2v2H3zM7 5h14v2H7zM3 11h2v2H3zM7 11h14v2H7zM3 17h2v2H3zM7 17h14v2H7z'/%3e%3c/svg%3e\"); }\r\n.icon--view-grid { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M3 3h8v8H3zM13 3h8v8h-8zM3 13h8v8H3zM13 13h8v8h-8z'/%3e%3c/svg%3e\"); }\r\n.icon--info { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 15h-2v-6h2zm0-8h-2V7h2z'/%3e%3c/svg%3e\"); }\r\n.icon--page-first { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M6 6h2v12H6zM19 6v12l-9-6z'/%3e%3c/svg%3e\"); }\r\n.icon--page-prev { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M15 6v12l-9-6z'/%3e%3c/svg%3e\"); }\r\n.icon--page-next { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M9 6v12l9-6z'/%3e%3c/svg%3e\"); }\r\n.icon--page-last { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M16 6h2v12h-2zM5 6v12l9-6z'/%3e%3c/svg%3e\"); }\r\n.icon--clock { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z'/%3e%3c/svg%3e\"); }\r\n.icon--external { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3zM19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7h-2z'/%3e%3c/svg%3e\"); }\r\n.icon--bell { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5S10.5 3.17 10.5 4v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z'/%3e%3c/svg%3e\"); }\r\n.icon--person { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/%3e%3c/svg%3e\"); }\r\n.icon--bell-filled { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z'/%3e%3c/svg%3e\"); }\r\n.icon--comment { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M12 2C6.48 2 2 5.81 2 10.5c0 2.68 1.46 5.07 3.75 6.64-.13 1.2-.64 2.3-1.42 3.16-.26.28-.05.74.33.7 2-.2 3.67-.9 4.9-1.85.77.16 1.58.25 2.44.25 5.52 0 10-3.81 10-8.5S17.52 2 12 2z'/%3e%3c/svg%3e\"); }\r\n.icon--expand { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M4 9V4h5v2H6v3zM15 4h5v5h-2V6h-3zM6 15v3h3v2H4v-5zM18 15h2v5h-5v-2h3z'/%3e%3c/svg%3e\"); }\r\n.icon--collapse { --icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M9 4v5H4V7h3V4zM15 4h2v3h3v2h-5zM4 15h5v5H7v-3H4zM20 15v2h-3v3h-2v-5z'/%3e%3c/svg%3e\"); }\r\n\r\n/* Per-context icon sizing. The base icon tracks font-size (1em); these tune the\r\n   handful of spots where the surrounding font-size doesn't map to the wanted glyph size. */\r\n.filter-toggle__icon.icon { width: 1.35rem; height: 1.35rem; }\r\n.admin-menu__icon .icon,\r\n.account-menu__icon .icon { width: 1.15rem; height: 1.15rem; }\r\n.panel-close .icon { width: 1.1rem; height: 1.1rem; }\r\n.filter-search__clear .icon,\r\n.saved-search__delete .icon { width: 0.85rem; height: 0.85rem; }\r\n.saved-search__bell .icon { width: 0.95rem; height: 0.95rem; }\r\n.release-card__bell .icon { width: 1.15rem; height: 1.15rem; }\r\n.filter-search-action .icon { width: 1.1rem; height: 1.1rem; }\r\n.view-toggle__btn .icon { width: 1.15rem; height: 1.15rem; }\r\n.updated-info__btn .icon { width: 1.15rem; height: 1.15rem; }\r\n.releases-expand__btn .icon { width: 1.15rem; height: 1.15rem; }\r\n.releases-pager__btn .icon { width: 1rem; height: 1rem; }\r\n.nav-btn .icon { width: 1rem; height: 1rem; }\r\n.release-source--link .icon { width: 0.85em; height: 0.85em; vertical-align: -0.05em; }\r\n.release-time__icon.icon { width: 3rem; height: 3rem; }\r\n.release-card--grid .release-time__icon.icon { width: 1rem; height: 1rem; }\r\n\r\n/* Filter toggle (top-left of the header) — only shown on mobile. */\r\n.filter-toggle {\r\n  display: none;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 1rem;\r\n  transform: translateY(-50%);\r\n  width: 2.6rem;\r\n  height: 2.6rem;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0;\r\n  background: rgba(255, 255, 255, 0.08);\r\n  border: 1px solid rgba(255, 255, 255, 0.18);\r\n  border-radius: 8px;\r\n  color: #e6ecf5;\r\n  cursor: pointer;\r\n  z-index: 200;\r\n  transition: background 0.2s, border-color 0.2s;\r\n}\r\n\r\n.filter-toggle:hover {\r\n  background: rgba(255, 255, 255, 0.18);\r\n  border-color: #6ab0ff;\r\n}\r\n\r\n.filter-toggle__icon {\r\n  font-size: 1.25rem;\r\n  line-height: 1;\r\n}\r\n\r\n/* Drawer close buttons ([X]) — only shown on mobile. */\r\n.panel-close {\r\n  display: none;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 1.9rem;\r\n  height: 1.9rem;\r\n  padding: 0;\r\n  background: transparent;\r\n  color: #c3ccdb;\r\n  border: 1px solid transparent;\r\n  border-radius: 6px;\r\n  font-size: 1rem;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  transition: color 0.2s, background 0.2s;\r\n}\r\n\r\n.panel-close:hover {\r\n  color: #fff;\r\n  background: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n/* Dark scrim behind an open mobile drawer. */\r\n.panel-backdrop {\r\n  display: none;\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 200;\r\n  background: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.header-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n/* Header controls cluster: holds the account and admin menus side by side, pinned to the\r\n   right edge of the header. Vertically centered via top/bottom + flex (no transform) so the\r\n   menus' fixed-position backdrops remain anchored to the viewport and can catch outside\r\n   clicks across the whole page. A transform here would trap those fixed backdrops inside\r\n   this box. */\r\n.header-actions {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: 1.25rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  z-index: 200;\r\n}\r\n\r\n.admin-menu {\r\n  position: relative;\r\n}\r\n\r\n.hamburger-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2.6rem;\r\n  height: 2.6rem;\r\n  padding: 0;\r\n  background: rgba(255, 255, 255, 0.08);\r\n  border: 1px solid rgba(255, 255, 255, 0.18);\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: background 0.2s, border-color 0.2s;\r\n}\r\n\r\n.hamburger-btn:hover:not(:disabled),\r\n.hamburger-btn.active {\r\n  background: rgba(255, 255, 255, 0.18);\r\n  border-color: #6ab0ff;\r\n}\r\n\r\n.hamburger-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.hamburger-btn__bars,\r\n.hamburger-btn__bars::before,\r\n.hamburger-btn__bars::after {\r\n  display: block;\r\n  width: 1.15rem;\r\n  height: 2px;\r\n  background: #e6ecf5;\r\n  border-radius: 2px;\r\n  transition: transform 0.2s, opacity 0.2s;\r\n}\r\n\r\n.hamburger-btn__bars {\r\n  position: relative;\r\n}\r\n\r\n.hamburger-btn__bars::before,\r\n.hamburger-btn__bars::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n}\r\n\r\n.hamburger-btn__bars::before {\r\n  top: -6px;\r\n}\r\n\r\n.hamburger-btn__bars::after {\r\n  top: 6px;\r\n}\r\n\r\n.hamburger-btn.active .hamburger-btn__bars {\r\n  background: transparent;\r\n}\r\n\r\n.hamburger-btn.active .hamburger-btn__bars::before {\r\n  transform: translateY(6px) rotate(45deg);\r\n}\r\n\r\n.hamburger-btn.active .hamburger-btn__bars::after {\r\n  transform: translateY(-6px) rotate(-45deg);\r\n}\r\n\r\n.admin-menu__backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 40;\r\n}\r\n\r\n.admin-menu__dropdown {\r\n  position: absolute;\r\n  top: calc(100% + 0.5rem);\r\n  right: 0;\r\n  z-index: 50;\r\n  min-width: 12rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0.35rem;\r\n  background: #1e2f47;\r\n  border: 1px solid rgba(255, 255, 255, 0.12);\r\n  border-radius: 10px;\r\n  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.admin-menu__item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  width: 100%;\r\n  padding: 0.55rem 0.7rem;\r\n  background: transparent;\r\n  color: #e6ecf5;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 0.95rem;\r\n  text-align: left;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.admin-menu__item:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.admin-menu__item.active {\r\n  background: rgba(74, 158, 255, 0.25);\r\n}\r\n\r\n.admin-menu__item:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.admin-menu__icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 1.25rem;\r\n}\r\n\r\n.account-menu {\r\n  position: relative;\r\n}\r\n\r\n.account-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 2.6rem;\r\n  padding: 0 0.9rem;\r\n  background: rgba(255, 255, 255, 0.08);\r\n  border: 1px solid rgba(255, 255, 255, 0.18);\r\n  border-radius: 8px;\r\n  color: #e6ecf5;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  transition: background 0.2s, border-color 0.2s;\r\n}\r\n\r\n.account-btn:hover:not(:disabled),\r\n.account-btn.active {\r\n  background: rgba(255, 255, 255, 0.18);\r\n  border-color: #6ab0ff;\r\n}\r\n\r\n/* The authenticated (avatar-only) menu button is squared to a 1:1 ratio so it\r\n   matches the other icon buttons in the header. The Sign-in button keeps its\r\n   text width via the --signin override below. */\r\n.account-btn:not(.account-btn--signin) {\r\n  width: 2.6rem;\r\n  padding: 0;\r\n}\r\n\r\n.account-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.account-btn--signin {\r\n  font-weight: 600;\r\n}\r\n\r\n.account-btn__avatar {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 1.7rem;\r\n  height: 1.7rem;\r\n  border-radius: 50%;\r\n  background: #2f6bd8;\r\n  color: #fff;\r\n  font-weight: 600;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.account-menu__backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 40;\r\n}\r\n\r\n.account-menu__dropdown {\r\n  position: absolute;\r\n  top: calc(100% + 0.5rem);\r\n  right: 0;\r\n  z-index: 50;\r\n  min-width: 12rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0.35rem;\r\n  background: #1e2f47;\r\n  border: 1px solid rgba(255, 255, 255, 0.12);\r\n  border-radius: 10px;\r\n  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.account-menu__identity {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.15rem;\r\n  padding: 0.5rem 0.7rem;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.account-menu__name {\r\n  color: #e6ecf5;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  word-break: break-word;\r\n}\r\n\r\n.account-menu__tier {\r\n  color: #8fa6c4;\r\n  font-size: 0.75rem;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.account-menu__item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  width: 100%;\r\n  padding: 0.55rem 0.7rem;\r\n  background: transparent;\r\n  color: #e6ecf5;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 0.95rem;\r\n  text-align: left;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.account-menu__item:hover {\r\n  background: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.account-menu__icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 1.25rem;\r\n}\r\n\r\n.app-header .subtitle {\r\n  font-size: 1.1rem;\r\n  color: #aaa;\r\n}\r\n\r\n.month-select {\r\n  padding: 0.15rem 1.5rem;\r\n  background-color: transparent;\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M7 10l5 5 5-5z' fill='%23ffffff'/%3e%3c/svg%3e\");\r\n  background-repeat: no-repeat;\r\n  background-position: right 0.4rem center;\r\n  background-size: 0.8rem;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 1.35rem;\r\n  font-weight: 700;\r\n  text-align: center;\r\n  text-align-last: center;\r\n  appearance: none;\r\n}\r\n\r\n/* The native dropdown popup renders on a light background, so give the options dark\r\n   text for readable contrast (the closed control keeps its light-on-dark header styling). */\r\n.month-select option {\r\n  color: #1a2040;\r\n}\r\n\r\n.month-select:hover:not(:disabled) {\r\n  color: #cfe0ff;\r\n}\r\n\r\n.month-select:focus-visible {\r\n  outline: 2px solid #6ab0ff;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.month-select:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.nav-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2.2rem;\r\n  height: 2.2rem;\r\n  padding: 0;\r\n  background: rgba(255, 255, 255, 0.08);\r\n  color: #dfe4ee;\r\n  border: 1px solid rgba(255, 255, 255, 0.16);\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  line-height: 1;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.nav-btn:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.18);\r\n  color: #fff;\r\n}\r\n\r\n.nav-btn:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.icon-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: relative;\r\n  width: 2.2rem;\r\n  height: 2.2rem;\r\n  padding: 0;\r\n  background: #2a4a6a;\r\n  color: #fff;\r\n  border: 1px solid #4a9eff;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  line-height: 1;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.icon-btn:hover:not(:disabled) {\r\n  background: #3a5a7a;\r\n}\r\n\r\n.icon-btn.active {\r\n  background: #4a9eff;\r\n  border-color: #6ab0ff;\r\n}\r\n\r\n.icon-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.icon-spinner {\r\n  display: inline-flex;\r\n  line-height: 1;\r\n}\r\n\r\n.spinner-ring {\r\n  display: inline-block;\r\n  width: 1rem;\r\n  height: 1rem;\r\n  border: 2px solid rgba(255, 255, 255, 0.3);\r\n  border-top-color: #fff;\r\n  border-radius: 50%;\r\n  animation: icon-spin 0.7s linear infinite;\r\n}\r\n\r\n@keyframes icon-spin {\r\n  from { transform: rotate(0deg); }\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n/* --- Filters (always-visible left panel) --- */\r\n\r\n.panel-left {\r\n  background: linear-gradient(150deg, #545d73 0%, #434c60 52%, #3b4559 100%);\r\n  border-radius: 10px;\r\n  padding: 1rem;\r\n  /* Account for the fixed header height so the internally-scrolling panel isn't clipped at the bottom. */\r\n  max-height: calc(100vh - 160px - var(--app-header-height));\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n  overflow: hidden;\r\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.07);\r\n}\r\n\r\n.filter-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* The Sources group grows to consume the panel's remaining height so its checklist can extend to\r\n   the panel's max-height (matching the RELEASES panel) instead of being capped at a fixed size.\r\n   min-height: 0 lets the inner scroll area shrink correctly inside the flex column. */\r\n.filter-group--sources {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n}\r\n\r\n.filter-group__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 0.4rem;\r\n}\r\n\r\n.filter-group__label {\r\n  font-size: 0.72rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: #c3ccdb;\r\n  display: block;\r\n  margin-bottom: 0.4rem;\r\n}\r\n\r\n.filter-group__header .filter-group__label {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.filter-group__actions {\r\n  display: flex;\r\n  gap: 0.3rem;\r\n}\r\n\r\n.filter-action {\r\n  background: none;\r\n  border: none;\r\n  color: #9ecbff;\r\n  font-size: 0.65rem;\r\n  cursor: pointer;\r\n  padding: 0.1rem 0.3rem;\r\n  border-radius: 3px;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.filter-action:hover {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  color: #fff;\r\n}\r\n\r\n.filter-checklist {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.15rem;\r\n  flex: 1 1 auto;\r\n  min-height: 6rem;\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n}\r\n\r\n/* Shared dark-theme scrollbar styling. Applied to every scroll container so the\r\n   Filter panel, Releases panel, saved-search list, log view and the main app\r\n   container all match instead of some falling back to the heavier default browser scrollbar. */\r\n.filter-checklist,\r\n.releases-list,\r\n.saved-search__list,\r\n.log-content,\r\n.app-container {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;\r\n}\r\n\r\n.filter-checklist::-webkit-scrollbar,\r\n.releases-list::-webkit-scrollbar,\r\n.saved-search__list::-webkit-scrollbar,\r\n.log-content::-webkit-scrollbar,\r\n.app-container::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.filter-checklist::-webkit-scrollbar-thumb,\r\n.releases-list::-webkit-scrollbar-thumb,\r\n.saved-search__list::-webkit-scrollbar-thumb,\r\n.log-content::-webkit-scrollbar-thumb,\r\n.app-container::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-radius: 4px;\r\n}\r\n\r\n.filter-checklist::-webkit-scrollbar-thumb:hover,\r\n.releases-list::-webkit-scrollbar-thumb:hover,\r\n.saved-search__list::-webkit-scrollbar-thumb:hover,\r\n.log-content::-webkit-scrollbar-thumb:hover,\r\n.app-container::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(255, 255, 255, 0.35);\r\n}\r\n\r\n.filter-check {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 0.25rem 0.35rem;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 0.8rem;\r\n  color: #e4e8f0;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.filter-check:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.filter-check input[type='checkbox'] {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  flex-shrink: 0;\r\n  accent-color: #4a9eff;\r\n  cursor: pointer;\r\n}\r\n\r\n.filter-check__label {\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.filter-search-wrap {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.filter-search {\r\n  width: 100%;\r\n  padding: 0.4rem 1.8rem 0.4rem 0.6rem;\r\n  font-size: 0.8rem;\r\n  background: transparent;\r\n  color: #eee;\r\n  border: none;\r\n  border-radius: 0;\r\n  outline: none;\r\n}\r\n\r\n.filter-search__clear {\r\n  position: absolute;\r\n  right: 0.4rem;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 1.1rem;\r\n  height: 1.1rem;\r\n  padding: 0;\r\n  background: #3a4a6a;\r\n  color: #ccc;\r\n  border: none;\r\n  border-radius: 50%;\r\n  font-size: 0.65rem;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.filter-search__clear:hover {\r\n  background: #e94560;\r\n  color: #fff;\r\n}\r\n\r\n.filter-search::placeholder {\r\n  color: #9aa3b4;\r\n}\r\n\r\n.saved-search {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.filter-search-row {\r\n  display: flex;\r\n  align-items: stretch;\r\n  background: rgba(15, 22, 41, 0.55);\r\n  border: 1px solid rgba(255, 255, 255, 0.18);\r\n  border-radius: 6px;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.filter-search-row:focus-within {\r\n  border-color: #4a9eff;\r\n}\r\n\r\n.filter-search-row .filter-search-wrap {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.filter-search-action {\r\n  flex-shrink: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2.1rem;\r\n  padding: 0;\r\n  background: transparent;\r\n  color: #cdd8e6;\r\n  border: none;\r\n  border-left: 1px solid rgba(255, 255, 255, 0.18);\r\n  border-radius: 0;\r\n  font-size: 0.95rem;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.filter-search-action:hover,\r\n.filter-search-action.active {\r\n  background: rgba(255, 255, 255, 0.12);\r\n  color: #fff;\r\n}\r\n\r\n.filter-search-action:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.filter-search-action:disabled:hover {\r\n  background: transparent;\r\n  color: #cdd8e6;\r\n}\r\n\r\n.filter-search-load {\r\n  position: relative;\r\n  display: flex;\r\n}\r\n\r\n.filter-search-load .filter-search-action {\r\n  border-radius: 0 5px 5px 0;\r\n}\r\n\r\n.saved-search-menu__backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 40;\r\n}\r\n\r\n.saved-search-menu__dropdown {\r\n  position: absolute;\r\n  top: calc(100% + 0.4rem);\r\n  right: 0;\r\n  z-index: 50;\r\n  width: max(14rem, 100%);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n  padding: 0.5rem;\r\n  background: #1e2f47;\r\n  border: 1px solid rgba(255, 255, 255, 0.12);\r\n  border-radius: 10px;\r\n  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.saved-search__list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.2rem;\r\n  max-height: 9rem;\r\n  overflow-y: auto;\r\n  padding-right: 0.25rem;\r\n}\r\n\r\n.saved-search__empty {\r\n  margin: 0;\r\n  color: #aab3c4;\r\n  font-style: italic;\r\n  font-size: 0.78rem;\r\n  padding: 0.2rem 0.35rem;\r\n}\r\n\r\n.saved-search__error {\r\n  margin: 0.1rem 0 0;\r\n  color: #ff9b9b;\r\n  font-size: 0.75rem;\r\n  padding: 0.1rem 0.35rem;\r\n}\r\n\r\n.saved-search__hint {\r\n  margin: 0.1rem 0 0;\r\n  color: #8fa6c4;\r\n  font-size: 0.72rem;\r\n  padding: 0.1rem 0.35rem;\r\n}\r\n\r\n.saved-search__item {\r\n  display: flex;\r\n  align-items: stretch;\r\n  gap: 0;\r\n  border: 1px solid rgba(255, 255, 255, 0.12);\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.saved-search__load {\r\n  flex: 1;\r\n  min-width: 0;\r\n  text-align: left;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  padding: 0.3rem 0.45rem;\r\n  font-size: 0.8rem;\r\n  background: rgba(255, 255, 255, 0.05);\r\n  color: #e4e8f0;\r\n  border: none;\r\n  border-radius: 0;\r\n  cursor: pointer;\r\n  transition: background 0.2s, border-color 0.2s;\r\n}\r\n\r\n.saved-search__load:hover {\r\n  background: rgba(255, 255, 255, 0.12);\r\n}\r\n\r\n.saved-search__delete {\r\n  flex-shrink: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 1.5rem;\r\n  padding: 0;\r\n  background: #3a4a6a;\r\n  color: #ccc;\r\n  border: none;\r\n  border-left: 1px solid rgba(255, 255, 255, 0.12);\r\n  border-radius: 0;\r\n  font-size: 0.7rem;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.saved-search__delete:hover {\r\n  background: #e94560;\r\n  color: #fff;\r\n}\r\n\r\n/* Scale the busy spinner to the compact delete button and keep the hover tint off while pending. */\r\n.saved-search__delete .spinner-ring {\r\n  width: 0.85rem;\r\n  height: 0.85rem;\r\n  border-width: 2px;\r\n}\r\n\r\n.saved-search__delete:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  background: #3a4a6a;\r\n  color: #ccc;\r\n}\r\n\r\n.saved-search__bell {\r\n  flex-shrink: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 1.5rem;\r\n  padding: 0;\r\n  background: #3a4a6a;\r\n  color: #ccc;\r\n  border: none;\r\n  border-left: 1px solid rgba(255, 255, 255, 0.12);\r\n  border-radius: 0;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.saved-search__bell:hover {\r\n  background: #4a5a7a;\r\n  color: #fff;\r\n}\r\n\r\n.saved-search__bell.is-active {\r\n  background: #6366f1;\r\n  color: #fff;\r\n}\r\n\r\n.saved-search__bell.is-active:hover {\r\n  background: #7275f3;\r\n}\r\n\r\n.loading {\r\n  text-align: center;\r\n  padding: 2rem;\r\n  color: #aaa;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.error {\r\n  text-align: center;\r\n  padding: 1rem;\r\n  color: #ff6b6b;\r\n  background: #2d1b1b;\r\n  border-radius: 8px;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n/* --- Two-panel horizontal layout --- */\r\n\r\n.main-layout {\r\n  display: grid;\r\n  grid-template-columns: 260px 1fr 700px;\r\n  gap: 1rem;\r\n  align-items: start;\r\n  /* Absorb the free vertical space inside .app-container so the footer is pushed\r\n     to the bottom of the viewport when the content is shorter than the page. */\r\n  flex: 1 0 auto;\r\n}\r\n\r\n/* Stack the three main panels (filter / calendar / releases) above every idle\r\n   animation stage so decorative animations always render layered BETWEEN the\r\n   panels and the background, never over the panels themselves. The animation\r\n   stages sit at negative or low z-index (.idle-stage--fullpage/.idle-stage--page\r\n   at -1, .toy-parade-strip at 0, .idle-stage--calendar at 1); giving the panels\r\n   a positive z-index keeps all of them below the panels. position: relative is\r\n   required for z-index to take effect on these grid items. */\r\n.panel-left,\r\n.panel-center,\r\n.panel-right {\r\n  position: relative;\r\n  z-index: 5;\r\n}\r\n\r\n/* Expanded releases: collapse to a single column and let the releases panel span it,\r\n   hiding the filter and calendar so the releases fill the entire main layout. Scoped to the\r\n   full three-column desktop layout; below 1250px the panel is already full-width or a drawer. */\r\n@media (min-width: 1251px) {\r\n  .main-layout.is-expanded {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .main-layout.is-expanded > .panel-left,\r\n  .main-layout.is-expanded > .panel-center {\r\n    display: none;\r\n  }\r\n\r\n  .main-layout.is-expanded > .panel-right {\r\n    grid-column: 1 / -1;\r\n  }\r\n\r\n  /* With the panel spanning the full layout there is room for many more cards per row. */\r\n  .main-layout.is-expanded .releases-list--grid {\r\n    grid-template-columns: repeat(10, 1fr);\r\n  }\r\n}\r\n\r\n/* --- Calendar header (month navigation lives here) --- */\r\n\r\n.calendar-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  padding-bottom: 0.6rem;\r\n  margin-bottom: 0.75rem;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.18);\r\n}\r\n\r\n/* Keeps the nav group visually centered by mirroring the reload button's width. */\r\n.calendar-header__spacer {\r\n  width: 2.2rem;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.calendar-header__nav {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n/* --- Releases header (title / date / view controls) --- */\r\n\r\n.releases-header {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto 1fr;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.18);\r\n  margin-bottom: 0.5rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.releases-header__title {\r\n  font-size: 0.85rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: #c3ccdb;\r\n  justify-self: start;\r\n}\r\n\r\n.releases-header__date {\r\n  font-size: 1.3rem;\r\n  font-weight: 700;\r\n  color: #fff;\r\n  white-space: nowrap;\r\n  justify-self: center;\r\n  text-align: center;\r\n}\r\n\r\n.releases-header__actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  justify-self: end;\r\n}\r\n\r\n.view-toggle {\r\n  display: inline-flex;\r\n  border: 1px solid #4a9eff;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.view-toggle__btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 2rem;\r\n  height: 1.9rem;\r\n  padding: 0 0.4rem;\r\n  background: #16213e;\r\n  color: #aab6c6;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 0.95rem;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.view-toggle__btn + .view-toggle__btn {\r\n  border-left: 1px solid #4a9eff;\r\n}\r\n\r\n.view-toggle__btn:hover:not(.active) {\r\n  background: #1e2a4a;\r\n  color: #fff;\r\n}\r\n\r\n.view-toggle__btn.active {\r\n  background: #2a4a6a;\r\n  color: #fff;\r\n}\r\n\r\n.updated-info {\r\n  position: relative;\r\n  display: inline-flex;\r\n}\r\n\r\n.updated-info__btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 1.9rem;\r\n  height: 1.9rem;\r\n  padding: 0;\r\n  background: transparent;\r\n  color: #6a7a8a;\r\n  border: 1px solid transparent;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  transition: color 0.2s, background 0.2s, border-color 0.2s;\r\n}\r\n\r\n.updated-info__btn:hover,\r\n.updated-info__btn.active {\r\n  color: #4a9eff;\r\n  background: #1e2a4a;\r\n}\r\n\r\n.updated-info__popover {\r\n  position: absolute;\r\n  top: calc(100% + 0.4rem);\r\n  right: 0;\r\n  z-index: 20;\r\n  padding: 0.35rem 0.6rem;\r\n  background: #0f1629;\r\n  border: 1px solid #333;\r\n  border-radius: 6px;\r\n  font-size: 0.7rem;\r\n  color: #aab6c6;\r\n  white-space: nowrap;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n/* Expand/collapse toggle: matches the info button's ghost style. Hidden on the small-screen\r\n   layouts where the releases panel is already full-width or a drawer. */\r\n.releases-expand__btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 1.9rem;\r\n  height: 1.9rem;\r\n  padding: 0;\r\n  background: transparent;\r\n  color: #6a7a8a;\r\n  border: 1px solid #4a9eff;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  transition: color 0.2s, background 0.2s, border-color 0.2s;\r\n}\r\n\r\n.releases-expand__btn:hover,\r\n.releases-expand__btn.active {\r\n  color: #4a9eff;\r\n  background: #1e2a4a;\r\n}\r\n\r\n/* --- Log section (below calendar, collapsible) --- */\r\n\r\n.log-section {\r\n  margin-top: 1rem;\r\n}\r\n\r\n.log-toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.log-count {\r\n  font-size: 0.72rem;\r\n  color: #8ab4f8;\r\n  font-family: 'Cascadia Code', 'Fira Code', monospace;\r\n}\r\n\r\n.log-toolbar-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.log-clear-btn {\r\n  font-size: 0.72rem;\r\n  color: #8ab4f8;\r\n  background: #16213e;\r\n  border: 1px solid #2a3a5a;\r\n  border-radius: 6px;\r\n  padding: 0.2rem 0.6rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.log-clear-btn:hover:not(:disabled) {\r\n  background: #1e2d4d;\r\n}\r\n\r\n.log-clear-btn:disabled {\r\n  opacity: 0.4;\r\n  cursor: default;\r\n}\r\n\r\n.log-content {\r\n  font-size: 0.72rem;\r\n  font-family: 'Cascadia Code', 'Fira Code', monospace;\r\n  color: #8ab4f8;\r\n  line-height: 1.5;\r\n  background: #16213e;\r\n  border-radius: 8px;\r\n  padding: 0.75rem;\r\n  margin-top: 0.5rem;\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.log-empty {\r\n  color: #555;\r\n  font-style: italic;\r\n}\r\n\r\n.diag-line {\r\n  padding: 0.2rem 0;\r\n  border-bottom: 1px solid #1a2a3a;\r\n}\r\n\r\n.diag-line:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n/* --- Center panel: Calendar --- */\r\n\r\n.panel-center {\r\n  min-width: 0;\r\n  background: linear-gradient(150deg, #545d73 0%, #434c60 52%, #3b4559 100%);\r\n  border-radius: 10px;\r\n  padding: 1rem;\r\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.07);\r\n}\r\n\r\n.calendar-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(7, 1fr);\r\n  gap: 2px;\r\n  background: #5b657c;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  padding: 2px;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.calendar-grid.is-loading {\r\n  opacity: 0.5;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Wrapper positions the loading overlay over the grid while a month's data loads. */\r\n.calendar-grid-wrap {\r\n  position: relative;\r\n}\r\n\r\n.calendar-loading-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  z-index: 5;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.75rem;\r\n  border-radius: 10px;\r\n  background: rgba(59, 69, 89, 0.35);\r\n  backdrop-filter: blur(1px);\r\n}\r\n\r\n.calendar-loading-spinner {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  border: 3px solid rgba(255, 255, 255, 0.25);\r\n  border-top-color: #ffffff;\r\n  animation: icon-spin 0.7s linear infinite;\r\n}\r\n\r\n.calendar-loading-text {\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  color: #e7edf6;\r\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.day-header {\r\n  text-align: center;\r\n  padding: 0.6rem 0.25rem;\r\n  font-weight: 600;\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  color: #c3ccdb;\r\n  background: #4c5670;\r\n}\r\n\r\n.calendar-day {\r\n  background: #414b5f;\r\n  padding: 0.4rem;\r\n  min-height: 60px;\r\n  position: relative;\r\n  cursor: default;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.calendar-day.other-month {\r\n  background: #333c4d;\r\n  opacity: 0.4;\r\n}\r\n\r\n.calendar-day.has-releases {\r\n  cursor: pointer;\r\n  background: #49546b;\r\n}\r\n\r\n.calendar-day.has-releases:hover {\r\n  background: #576480;\r\n}\r\n\r\n.calendar-day.selected {\r\n  background: #3f5c84;\r\n  border: 2px solid #6ab0ff;\r\n}\r\n\r\n.day-number {\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  color: #eef1f6;\r\n}\r\n\r\n.calendar-day.today .day-number {\r\n  color: #4eff6a;\r\n  font-weight: 700;\r\n}\r\n\r\n.release-count {\r\n  position: absolute;\r\n  bottom: 4px;\r\n  right: 4px;\r\n  background: #e94560;\r\n  color: #fff;\r\n  font-size: 0.65rem;\r\n  font-weight: 700;\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* --- Right panel: Releases --- */\r\n\r\n.panel-right {\r\n  background: linear-gradient(150deg, #545d73 0%, #434c60 52%, #3b4559 100%);\r\n  border-radius: 10px;\r\n  padding: 1rem;\r\n  /* Account for the fixed header height so the internally-scrolling panel isn't clipped at the bottom. */\r\n  max-height: calc(100vh - 160px - var(--app-header-height));\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.07);\r\n}\r\n\r\n.releases-content {\r\n  font-size: 0.85rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n.releases-empty {\r\n  color: #aab3c4;\r\n  font-style: italic;\r\n  text-align: center;\r\n  padding: 1.5rem 0.5rem;\r\n}\r\n\r\n.releases-detail {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  min-height: 0;\r\n  /* Anchors the paging loading overlay over the list and pager. */\r\n  position: relative;\r\n}\r\n\r\n.releases-list {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  /* Prevent scroll chaining: once the list reaches its top/bottom, the wheel no longer\r\n     bubbles up and scrolls the whole page. */\r\n  overscroll-behavior: contain;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n/* Dim the outgoing page while the next one loads, matching the calendar grid's behaviour. */\r\n.releases-list.is-loading {\r\n  opacity: 0.5;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Grid view: compact cards laid out 4 per row. */\r\n.releases-list--grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 0.6rem;\r\n  align-content: start;\r\n}\r\n\r\n.releases-list--grid release {\r\n  display: block;\r\n  min-width: 0;\r\n}\r\n\r\n.releases-list--grid release + release {\r\n  margin-top: 0;\r\n}\r\n\r\n.releases-pager {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.75rem;\r\n  flex-shrink: 0;\r\n  padding-top: 0.75rem;\r\n  margin-top: 0.5rem;\r\n  border-top: 1px solid rgba(74, 158, 255, 0.18);\r\n}\r\n\r\n.releases-pager__btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 2rem;\r\n  height: 2rem;\r\n  padding: 0 0.5rem;\r\n  background: #2a4a6a;\r\n  color: #fff;\r\n  border: 1px solid #4a9eff;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 0.85rem;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.releases-pager__btn:hover:not(:disabled) {\r\n  background: #3a5a7a;\r\n}\r\n\r\n.releases-pager__btn:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.releases-pager__label {\r\n  color: #4a9eff;\r\n  font-size: 0.8rem;\r\n  min-width: 6.5rem;\r\n  text-align: center;\r\n}\r\n\r\nrelease {\r\n  display: block;\r\n}\r\n\r\nrelease + release {\r\n  margin-top: 1px;\r\n}\r\n\r\n.release-card {\r\n  background: #1e2a4a;\r\n  border-radius: 8px;\r\n  padding: 0;\r\n  margin-bottom: 0.6rem;\r\n  border-left: 3px solid #e94560;\r\n  overflow: hidden;\r\n}\r\n\r\n.release-card__body {\r\n  display: flex;\r\n  gap: 0;\r\n  align-items: stretch;\r\n}\r\n\r\n.release-thumb {\r\n  width: 90px;\r\n  min-height: 90px;\r\n  aspect-ratio: 1;\r\n  object-fit: cover;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n  transition: opacity 0.2s;\r\n  background: #0f1629;\r\n}\r\n\r\n.release-thumb:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n.release-card__content {\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding: 0.75rem;\r\n}\r\n\r\n.release-card__header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.release-card__info {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.release-card__meta {\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.release-card__bell {\r\n  flex-shrink: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 1.9rem;\r\n  height: 1.9rem;\r\n  padding: 0;\r\n  background: rgba(255, 255, 255, 0.06);\r\n  color: #9aa4bf;\r\n  border: 1px solid rgba(255, 255, 255, 0.12);\r\n  border-radius: 8px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  transition: background 0.2s, color 0.2s, border-color 0.2s;\r\n}\r\n\r\n.release-card--list .release-card__bell {\r\n  width: 1.6rem;\r\n  height: 1.6rem;\r\n}\r\n\r\n.release-card--list .release-card__bell .icon {\r\n  width: 0.95rem;\r\n  height: 0.95rem;\r\n}\r\n\r\n.release-card__bell:hover {\r\n  background: rgba(255, 255, 255, 0.12);\r\n  color: #e4e8f0;\r\n  border-color: rgba(158, 203, 255, 0.5);\r\n}\r\n\r\n.release-card__bell.is-active {\r\n  background: #6366f1;\r\n  color: #fff;\r\n  border-color: #6366f1;\r\n}\r\n\r\n.release-card__bell.is-active:hover {\r\n  background: #7275f3;\r\n  border-color: #7275f3;\r\n}\r\n\r\n.release-card:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.release-source {\r\n  font-size: 0.65rem;\r\n  text-transform: uppercase;\r\n  color: #888;\r\n  margin-bottom: 0.15rem;\r\n}\r\n\r\n.release-source--link {\r\n  text-decoration: none;\r\n  color: #888;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.release-source--link:hover {\r\n  color: #4a9eff;\r\n  text-decoration: underline;\r\n}\r\n\r\n.release-brand {\r\n  font-size: 0.95rem;\r\n  font-weight: 700;\r\n  color: #4a9eff;\r\n}\r\n\r\n.release-line {\r\n  font-size: 0.85rem;\r\n  color: #ccc;\r\n  margin-top: 0.15rem;\r\n}\r\n\r\n.release-time {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.15rem;\r\n  white-space: nowrap;\r\n  padding: 0.3rem 0.6rem;\r\n  background: #1a2040;\r\n  border-radius: 6px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.release-time__icon {\r\n  font-size: 1.4rem;\r\n  line-height: 1;\r\n}\r\n\r\n.release-time__text {\r\n  font-size: 1.05rem;\r\n  font-weight: 700;\r\n  color: #ffd700;\r\n}\r\n\r\n.release-note {\r\n  font-size: 0.75rem;\r\n  color: #888;\r\n  margin-top: 0.3rem;\r\n  font-style: italic;\r\n  line-height: 1.4;\r\n}\r\n\r\n.release-price {\r\n  font-size: 0.9rem;\r\n  font-weight: 700;\r\n  color: #4caf50;\r\n  white-space: nowrap;\r\n  margin-top: 0.3rem;\r\n}\r\n\r\n/* --- Grid-view compact card (stacked: image on top, details below) --- */\r\n\r\n.release-card--grid {\r\n  margin-bottom: 0;\r\n  height: 100%;\r\n}\r\n\r\n.release-card--grid .release-card__body {\r\n  flex-direction: column;\r\n}\r\n\r\n.release-card--grid .release-thumb {\r\n  width: 100%;\r\n  height: 130px;\r\n  min-height: 0;\r\n  aspect-ratio: auto;\r\n}\r\n\r\n.release-card--grid .release-card__content {\r\n  padding: 0.6rem;\r\n}\r\n\r\n.release-card--grid .release-card__header {\r\n  flex-direction: column;\r\n  gap: 0.35rem;\r\n}\r\n\r\n.release-card--grid .release-card__meta {\r\n  flex-direction: row;\r\n  align-items: center;\r\n  align-self: flex-start;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.release-card--grid .release-time {\r\n  flex-direction: row;\r\n  gap: 0.3rem;\r\n  padding: 0.2rem 0.45rem;\r\n  align-self: flex-start;\r\n}\r\n\r\n.release-card--grid .release-time__icon {\r\n  font-size: 1rem;\r\n}\r\n\r\n.release-card--grid .release-time__text {\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* --- Lightbox --- */\r\n\r\n/* --- Login modal --- */\r\n\r\n.modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.65);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1100;\r\n}\r\n\r\n.login-modal {\r\n  width: min(90vw, 340px);\r\n  background: #1c2c40;\r\n  border: 1px solid #4a9eff;\r\n  border-radius: 10px;\r\n  padding: 1.4rem;\r\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.9rem;\r\n}\r\n\r\n.login-modal__title {\r\n  margin: 0;\r\n  color: #fff;\r\n  font-size: 1.15rem;\r\n}\r\n\r\n.login-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.35rem;\r\n  color: #cdd8e6;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.login-field input {\r\n  padding: 0.55rem 0.6rem;\r\n  background: #12202f;\r\n  color: #fff;\r\n  border: 1px solid #34506e;\r\n  border-radius: 6px;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.login-field input:focus {\r\n  outline: none;\r\n  border-color: #4a9eff;\r\n}\r\n\r\n.login-check {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  color: #cdd8e6;\r\n  font-size: 0.85rem;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.login-check input[type='checkbox'] {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  flex-shrink: 0;\r\n  accent-color: #4a9eff;\r\n  cursor: pointer;\r\n}\r\n\r\n.login-error {\r\n  color: #ff8080;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.save-search__nudge {\r\n  margin: 0;\r\n  color: #9fb0c3;\r\n  font-size: 0.85rem;\r\n  line-height: 1.4;\r\n}\r\n\r\n.save-search__nudge-link {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  color: #4a9eff;\r\n  font: inherit;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n}\r\n\r\n.save-search__nudge-link:hover {\r\n  color: #6fb2ff;\r\n}\r\n\r\n.login-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 0.6rem;\r\n  margin-top: 0.2rem;\r\n}\r\n\r\n.login-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.4rem;\r\n  padding: 0.5rem 0.9rem;\r\n  border-radius: 6px;\r\n  border: 1px solid transparent;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.login-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.login-btn--primary {\r\n  background: #4a9eff;\r\n  color: #fff;\r\n}\r\n\r\n.login-btn--primary:hover:not(:disabled) {\r\n  background: #5aabff;\r\n}\r\n\r\n.login-btn--secondary {\r\n  background: transparent;\r\n  color: #cdd8e6;\r\n  border-color: #34506e;\r\n}\r\n\r\n.login-btn--secondary:hover:not(:disabled) {\r\n  background: #23384f;\r\n}\r\n\r\n/* --- Hidden admin sign-in hotspot ---\r\n   An invisible click target tucked into the bottom-right corner. It carries no\r\n   visible styling so only someone who knows it is there can find it. */\r\n.admin-hotspot {\r\n  position: fixed;\r\n  right: 0;\r\n  bottom: 0;\r\n  width: 28px;\r\n  height: 28px;\r\n  margin: 0;\r\n  padding: 0;\r\n  border: none;\r\n  background: transparent;\r\n  opacity: 0;\r\n  cursor: default;\r\n  z-index: 1200;\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\n.admin-hotspot:focus {\r\n  outline: none;\r\n}\r\n\r\n/* --- Footer --- */\r\n\r\n.app-footer {\r\n  position: relative;\r\n  margin-top: 2.5rem;\r\n  padding-top: 1.25rem;\r\n  border-top: 1px solid rgba(74, 158, 255, 0.18);\r\n  text-align: center;\r\n  color: #8a97a8;\r\n  font-size: 0.8rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.app-footer__links {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.4rem;\r\n  margin-bottom: 0.6rem;\r\n}\r\n\r\n.footer-link {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  color: #9fb4cc;\r\n  font-size: 0.8rem;\r\n  font-family: inherit;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.footer-link:hover {\r\n  color: #4a9eff;\r\n  text-decoration: underline;\r\n}\r\n\r\n.footer-link--icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  line-height: 0;\r\n}\r\n\r\n.footer-link--icon:hover {\r\n  text-decoration: none;\r\n}\r\n\r\n.footer-icon {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  display: block;\r\n}\r\n\r\n.footer-sep {\r\n  color: #4a5a6e;\r\n  user-select: none;\r\n}\r\n\r\n.app-footer__copyright {\r\n  color: #aab6c6;\r\n  margin-bottom: 0.4rem;\r\n}\r\n\r\n.app-footer__note {\r\n  max-width: 720px;\r\n  margin: 0 auto;\r\n  color: #6f7c8c;\r\n  font-size: 0.72rem;\r\n}\r\n\r\n.app-footer__made-in {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.35rem;\r\n  margin-top: 0.75rem;\r\n  color: #8a97a8;\r\n  font-size: 0.68rem;\r\n  letter-spacing: 0.08em;\r\n}\r\n\r\n.pr-flag {\r\n  width: 1.1rem;\r\n  height: auto;\r\n  border-radius: 2px;\r\n  display: block;\r\n}\r\n\r\n/* ------------------------------------------------------------------ */\r\n/* Responsive / mobile                                                */\r\n/* ------------------------------------------------------------------ */\r\n\r\n/* Narrow desktops / large tablets: keep the filter beside the calendar but move\r\n   the releases panel to a full-width row below so the calendar keeps usable width. */\r\n@media (max-width: 1250px) {\r\n  .main-layout {\r\n    grid-template-columns: 240px 1fr;\r\n  }\r\n\r\n  .panel-right {\r\n    grid-column: 1 / -1;\r\n  }\r\n\r\n  /* The releases panel is already full-width here, so the expand affordance is redundant. */\r\n  .releases-expand__btn {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Tablets and below: stack the filter, calendar, and releases panels so the\r\n   fixed sidebar no longer forces horizontal scrolling. */\r\n@media (max-width: 900px) {\r\n  .main-layout {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  /* When stacked, cap the filter panel height so its brand list stays scrollable\r\n     instead of pushing the calendar far down the page. */\r\n  .panel-left {\r\n    max-height: 320px;\r\n  }\r\n\r\n  /* When stacked, let the releases panel flow with the page instead of\r\n     trapping content inside a fixed-height inner scroll region. */\r\n  .panel-right {\r\n    max-height: none;\r\n    overflow: visible;\r\n  }\r\n\r\n  .releases-list {\r\n    overflow-y: visible;\r\n  }\r\n}\r\n\r\n/* Phones: tighten chrome, wrap the header controls, and enlarge touch\r\n   targets so the calendar stays usable on narrow screens. */\r\n@media (max-width: 600px) {\r\n  .app-container {\r\n    padding: 1rem 0.75rem;\r\n  }\r\n\r\n  .app-header h1 {\r\n    font-size: 1.4rem;\r\n    padding: 0 3.25rem;\r\n  }\r\n\r\n  .header-actions {\r\n    right: 0.75rem;\r\n  }\r\n\r\n  .filter-toggle {\r\n    display: inline-flex;\r\n    left: 0.75rem;\r\n  }\r\n\r\n  .header-row {\r\n    flex-wrap: wrap;\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  /* Only the calendar occupies the flow on mobile; the filter and releases\r\n     panels become slide-in drawers layered on top of it. */\r\n  .main-layout {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .panel-close {\r\n    display: inline-flex;\r\n  }\r\n\r\n  .panel-backdrop.is-open {\r\n    display: block;\r\n  }\r\n\r\n  /* Filter drawer: slides in from the left, over the calendar. */\r\n  .panel-left {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    width: min(88vw, 340px);\r\n    max-height: none;\r\n    z-index: 210;\r\n    border-radius: 0;\r\n    transform: translateX(-100%);\r\n    transition: transform 0.28s ease;\r\n  }\r\n\r\n  .panel-left.is-open {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  /* Releases drawer: slides in from the right, over the calendar. */\r\n  .panel-right {\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    width: min(94vw, 480px);\r\n    max-height: none;\r\n    overflow: hidden;\r\n    z-index: 210;\r\n    border-radius: 0;\r\n    padding: 0.75rem;\r\n    transform: translateX(100%);\r\n    transition: transform 0.28s ease;\r\n  }\r\n\r\n  .panel-right.is-open {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  .releases-list {\r\n    overflow-y: auto;\r\n  }\r\n\r\n  /* Recommended minimum ~44px touch targets. */\r\n  .nav-btn,\r\n  .icon-btn {\r\n    min-width: 2.75rem;\r\n    min-height: 2.75rem;\r\n  }\r\n\r\n  /* The reload button was added to the calendar header; on narrow screens the balancing\r\n     spacer + larger touch targets + 1rem gaps overflow the row. Drop the spacer (it only\r\n     exists to visually center the nav on desktop) and tighten spacing so the header fits. */\r\n  .calendar-header {\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  .calendar-header__spacer {\r\n    display: none;\r\n  }\r\n\r\n  .calendar-header__nav {\r\n    flex: 1 1 auto;\r\n    justify-content: center;\r\n    gap: 0.5rem;\r\n    min-width: 0;\r\n  }\r\n\r\n  /* Let the month select shrink instead of forcing the row wider than the viewport. */\r\n  .month-select {\r\n    min-width: 0;\r\n    flex: 0 1 auto;\r\n    font-size: 1.15rem;\r\n    padding: 0.15rem 1.35rem;\r\n  }\r\n\r\n  .calendar-header__reload {\r\n    flex: 0 0 auto;\r\n  }\r\n\r\n  .calendar-day {\r\n    min-height: 48px;\r\n    padding: 0.3rem;\r\n  }\r\n\r\n  .day-header {\r\n    padding: 0.4rem 0.15rem;\r\n    font-size: 0.65rem;\r\n  }\r\n\r\n  .day-number {\r\n    font-size: 0.8rem;\r\n  }\r\n\r\n  .releases-list--grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .release-thumb {\r\n    width: 72px;\r\n    min-height: 72px;\r\n  }\r\n\r\n  .release-card--grid .release-thumb {\r\n    width: 100%;\r\n    height: 110px;\r\n  }\r\n\r\n  .release-card__content {\r\n    padding: 0.6rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
